// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%232b6777%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg width=%2716%27 height=%2716%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M4 6l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
margin: 0;
padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* Enhanced Login Page Styles */
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f2f2f2;
  background: linear-gradient(135deg, #f2f2f2 0%, #c8d8e4 100%);
  overflow: hidden;
  position: relative;
}

.login-page::before {
  content: '';
  position: absolute;
  width: 300px;
  height: 300px;
  background-color: rgba(43, 103, 119, 0.1);
  border-radius: 50%;
  top: -150px;
  left: -100px;
  animation: float 15s infinite ease-in-out;
}

.login-page::after {
  content: '';
  position: absolute;
  width: 250px;
  height: 250px;
  background-color: rgba(82, 171, 152, 0.1);
  border-radius: 50%;
  bottom: -100px;
  right: -50px;
  animation: float 20s infinite ease-in-out reverse;
}

@keyframes float {
  0% { transform: translate(0, 0) rotate(0deg); }
  25% { transform: translate(10px, 20px) rotate(5deg); }
  50% { transform: translate(20px, 10px) rotate(0deg); }
  75% { transform: translate(10px, -10px) rotate(-5deg); }
  100% { transform: translate(0, 0) rotate(0deg); }
}

.login-container {
  z-index: 10;
  max-width: 450px;
  width: 100%;
  padding: 20px;
}

.tracker-header {
  text-align: center;
  margin-bottom: 30px;
}

.tracker-header h1 {
  font-size: 3rem;
  color: #2b6777;
  font-weight: 700;
  letter-spacing: 4px;
  margin-bottom: 0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  animation: fadeInDown 1s forwards;
}

.animated-underline {
  height: 4px;
  width: 0;
  background: linear-gradient(90deg, #2b6777, #52ab98);
  margin: 0 auto;
  border-radius: 2px;
  animation: expandWidth 1.5s forwards 0.5s;
}

@keyframes expandWidth {
  0% { width: 0; }
  100% { width: 180px; }
}

@keyframes fadeInDown {
  0% { 
    opacity: 0;
    transform: translateY(-20px);
  }
  100% { 
    opacity: 1;
    transform: translateY(0);
  }
}

.login-card {
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(43, 103, 119, 0.15);
  padding: 40px;
  text-align: center;
  transform: translateY(20px);
  opacity: 0;
  animation: fadeInUp 1s forwards 0.8s;
}

@keyframes fadeInUp {
  0% { 
    opacity: 0;
    transform: translateY(20px);
  }
  100% { 
    opacity: 1;
    transform: translateY(0);
  }
}

.login-card h2 {
  margin-bottom: 30px;
  color: #2b6777;
  font-size: 1.8rem;
  font-weight: 600;
}

.login-card form {
  display: flex;
  flex-direction: column;
}

.input-group {
  margin-bottom: 25px;
  text-align: left;
  position: relative;
}

.input-group label {
  display: block;
  margin-bottom: 8px;
  color: #2b6777;
  font-weight: 500;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.login-input {
  width: 100%;
  padding: 12px 15px;
  background-color: #f2f2f2;
  border: 2px solid transparent;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.login-input:focus {
  outline: none;
  border-color: #52ab98;
  box-shadow: 0 0 0 3px rgba(82, 171, 152, 0.2);
}

.login-input::placeholder {
  color: #a0a0a0;
}

.login-button {
  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
  color: white;
  padding: 14px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;
  position: relative;
  overflow: hidden;
}

.login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(43, 103, 119, 0.2);
}

.login-button:active {
  transform: translateY(0);
}

.login-button::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: -100%;
  background: linear-gradient(90deg, 
    rgba(255, 255, 255, 0.1), 
    rgba(255, 255, 255, 0.4), 
    rgba(255, 255, 255, 0.1)
  );
  transition: all 0.3s ease;
}

.login-button:hover::after {
  left: 100%;
}

.login-button.loading {
  background: #52ab98;
}

/* Spinner animation */
.spinner {
  display: flex;
  justify-content: center;
}

.spinner > div {
  width: 10px;
  height: 10px;
  margin: 0 3px;
  background-color: #ffffff;
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  animation-delay: -0.16s;
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

/* Original Styles Below */
.container {
  width: 100%;
}

.login{
  display: flex;
  align-items: center;
  height: 100vh;
}

/* Original login card styles - these are now overridden by the enhanced styles above for the login page */
.modal-body h2 {
  margin-bottom: 20px;
  color: #333;
}

.modal-body form {
  display: flex;
  flex-direction: column;
}

.modal-body label {
  text-align: left;
  margin-bottom: 8px;
  color: #555;
}

.modal-body input {
  padding: 10px;
  margin-bottom: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  width: 100%;
}

.modal-body button {
  background-color: #3083DC;
  color: #fff;
  padding: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.nr{white-space: nowrap;}
.bg-t{background: transparent !important;}
.admin-button{ 
  margin-top: 11rem;
}
.admin-button .bttn button{ width: 400px; height: 150px; background-color: #EAECF0; font-size: 20px; font-weight: 500; }

.header{ 
  background-color: #EAECF0; 
  border-radius: 8px; 
  padding: 7px; 
  margin-top: 11px;
}
.header h2{ 
  font-size: 25px; 
  padding: 6px 11px;
}

/* Message start */
.typing-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.typing-dot {
  width: 8px;
  height: 8px;
  background-color: #64c782;
  border-radius: 50%;
  margin: 0 4px;
  animation: bounce 1.4s infinite ease-in-out;
}

.typing-dot:nth-child(2) {
  animation-delay: 0.2s;
}

.typing-dot:nth-child(3) {
  animation-delay: 0.4s;
}

/* .chat-container {
} */

.header {
  background: #f5f8f5;
  padding: 10px;
}

.body {
  flex: 1 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  padding: 16px;
}

.user-details {
  display: flex;
  gap: 16px;
  align-items: center;
}

.user-details span {
  width: 60px;
  min-width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
}

.user-details span img {
  max-width: 100%;
  height: auto;
}

.user-info {
  display: flex;
  flex-direction: column;
}

.user-info h5 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
}

.user-info p {
  margin: 0;
  font-size: 16px;
  font-weight: 400;
}

.chat-box {
  position: relative;
  margin: 10px 0;
  padding: 10px 20px;
  border-radius: 10px;
  background-color: #e0e0e0;
  width: fit-content;
  max-width: 80%;
}

.chat-box p {
  margin: 0;
  color: #f5f5f5;
}

.chat-box.sender {
  background-color: #3083DC;
  align-self: flex-end;
  justify-self:flex-end ;
}

.chat-box.receiver {
  background-color: #5d99d8;
  align-self: flex-start;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.chat-box.sender::before {
  content: "";
  position: absolute;
  bottom: 1px;
  right: -15px;
  width: 15px;
  height: 20px;
  z-index: 9;
  border-radius: 0 0 0 20px;
  background: #fff;
}

.chat-box.sender::after {
  content: "";
  position: absolute;
  bottom: 0;
  right: -9px;
  width: 18px;
  height: 15px;
  background: #3083DC;
}

.chat-box.receiver::before {
  content: "";
  position: absolute;
  bottom: 1px;
  left: -15px;
  width: 15px;
  height: 20px;
  z-index: 1;
  border-radius: 0 0 20px 0;
  background: #fff;
}

.chat-box.receiver::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: -9px;
  width: 18px;
  height: 15px;
  background: #5d99d8;
}

.sender .status {
  text-align: right;
}

.status {
  font-size: 10px;
  margin-top: 5px;
  color: #999;
}

.input-container {
  margin-top: 16px;
  display: flex;
}

.input-container input {
  flex: 1 1;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-right: 8px;
}

.input-container button {
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 16px;
  cursor: pointer;
}

.text-red{
  color: red;
}

th.text-green{
  color: rgb(64, 203, 64);
}

.search-bar{
  width: 100%;
}

.color-blue{
  color: blue;
}

.cursor-pointer{
  cursor: pointer;
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* Message End */

/* New Admin Page Styles */
.admin-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f2f2f2 0%, #c8d8e4 70%);
  padding: 30px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  overflow-x: hidden;
}

.client-group-hours-table-wrap {
  max-height: 50vh;
  overflow: auto;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  -webkit-overflow-scrolling: touch;
}

.client-group-hours-table {
  border-collapse: separate;
  border-spacing: 0;
}

.client-group-hours-table thead th {
  position: sticky;
  top: 0;
  z-index: 3;
  background: #d7efe0;
  box-shadow: 0 1px 0 0 #dee2e6;
  white-space: nowrap;
}

.admin-container {
  max-width: 1200px;
  margin: 0 auto;
}

.admin-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 6px 15px rgba(43, 103, 119, 0.1);
  margin-bottom: 30px;
  animation: slideDown 0.8s ease-out forwards;
}

@keyframes slideDown {
  from {
    transform: translateY(-50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.admin-header h1 {
  color: #2b6777;
  font-size: 32px;
  font-weight: 700;
  margin: 0;
}

.logout-button {
  background-color: white;
  color: #2b6777;
  border: 2px solid #2b6777;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.logout-button:hover {
  background-color: #2b6777;
  color: white;
}

.logout-icon {
  display: flex;
  align-items: center;
}

.admin-dashboard {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 6px 15px rgba(43, 103, 119, 0.1);
  padding: 30px;
  animation: fadeIn 1.2s ease-out forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.dashboard-header {
  text-align: center;
  margin-bottom: 30px;
}

.dashboard-header h2 {
  color: #2b6777;
  font-size: 24px;
  margin-bottom: 10px;
}

.dashboard-header p {
  color: #666;
  font-size: 16px;
}

.admin-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.admin-card {
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
  padding: 24px;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border: 2px solid transparent;
}

.admin-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  background: linear-gradient(90deg, #2b6777, #52ab98);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.5s ease;
}

.admin-card:hover {
  transform: translateY(-5px);
  border-color: rgba(82, 171, 152, 0.2);
}

.admin-card:hover::before {
  transform: scaleX(1);
}

.card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 12px;
  margin-bottom: 16px;
  color: white;
}

.user-icon {
  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
}

.delete-icon {
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
}

.report-icon {
  background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
}

.ai-icon {
  background: linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%);
}

.tracking-icon {
  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
}

.worklog-icon {
  background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
}

.admin-worklog-filters {
  padding: 0;
}

.admin-worklog-date-row {
  display: flex;
  gap: 1rem;
}

.admin-worklog-date-field {
  flex: 1 1;
  min-width: 0;
}

.admin-worklog-request-btn {
  width: 100%;
}

.admin-worklog-back-btn {
  color: #2b6777;
  text-decoration: none;
  line-height: 1;
}

.admin-worklog-back-btn:hover {
  color: #1f5562;
}

.admin-worklog-results {
  max-height: min(65vh, 560px);
  overflow: auto;
}

.admin-worklog-json {
  font-size: 0.8125rem;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  padding: 0.75rem;
  white-space: pre-wrap;
  word-break: break-word;
}

.admin-worklog-report {
  --worklog-accent: #d97706;
  --worklog-accent-soft: #fff7ed;
}

.admin-worklog-stat-card {
  background: #f8fafb;
  border: 1px solid #e3e9ef;
  border-radius: 10px;
  padding: 0.85rem 1rem;
}

.admin-worklog-stat-card--accent {
  background: var(--worklog-accent-soft);
  border-color: #fed7aa;
}

.admin-worklog-stat-label {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  margin-bottom: 0.35rem;
}

.admin-worklog-stat-value {
  font-size: 1.05rem;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.35;
}

.admin-worklog-stat-value--sm {
  font-size: 0.9rem;
  font-weight: 500;
}

.admin-worklog-section-title {
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #2b6777;
  margin-bottom: 0.65rem;
}

.admin-worklog-section-title--warning {
  color: #b45309;
}

.admin-worklog-repo-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.admin-worklog-repo-badge {
  background: #e9f3f5;
  color: #000;
  border: 1px solid #b8d4da;
  font-weight: 500;
  font-size: 0.78rem;
  padding: 0.4em 0.75em;
}

.admin-worklog-table-wrap {
  border: 1px solid #e3e9ef;
  border-radius: 8px;
  overflow: hidden;
}

.admin-worklog-table thead th {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  white-space: nowrap;
}

.admin-worklog-desc-cell {
  min-width: 10rem;
  max-width: 16rem;
}

.admin-worklog-commits-cell {
  min-width: 8rem;
  max-width: 14rem;
}

.admin-worklog-commit-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
}

.admin-worklog-commit-tag {
  font-size: 0.68rem;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 0.1rem 0.35rem;
  color: #334155;
}

.admin-worklog-verify-link {
  font-size: 0.8125rem;
  font-weight: 600;
  text-decoration: none;
}

.admin-worklog-verify-link:hover {
  text-decoration: underline;
}

.admin-worklog-blockers-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.admin-worklog-blockers-list li {
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-left: 3px solid var(--worklog-accent);
  border-radius: 6px;
  padding: 0.55rem 0.75rem;
  font-size: 0.875rem;
  color: #7c2d12;
}

.card-content h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #2b6777;
}

.card-content p {
  color: #666;
  font-size: 14px;
  margin: 0;
}

/* Modal Styling Updates */
.modal-content {
  border-radius: 12px;
  border: none;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.modal-header {
  background-color: #2b6777;
  color: white;
  border-bottom: none;
}

.modal-header .modal-title {
  font-weight: 600;
}

.modal-header .btn-close {
  color: white;
  opacity: 0.8;
}

.modal-footer {
  border-top: none;
  padding-top: 0;
}

.btn-primary {
  background-color: #2b6777;
  border-color: #2b6777;
}

.btn-primary:hover {
  background-color: #52ab98;
  border-color: #52ab98;
}

.btn-secondary {
  background-color: #c8d8e4;
  border-color: #c8d8e4;
  color: #2b6777;
}

.btn-secondary:hover {
  background-color: #a1c6de;
  border-color: #a1c6de;
  color: #2b6777;
}

.form-control:focus {
  border-color: #52ab98;
  box-shadow: 0 0 0 0.25rem rgba(82, 171, 152, 0.25);
}

/* Enhanced Modal Styles for Add User and Delete User */
.user-modal .modal-content {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 15px 30px rgba(43, 103, 119, 0.2);
  border: none;
}

.user-modal .modal-header {
  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
  color: #ffffff;
  padding: 20px 24px;
  border-bottom: none;
}

.user-modal .modal-header .modal-title {
  font-size: 1.5rem;
  font-weight: 600;
}

.user-modal .modal-header .btn-close {
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  padding: 6px;
  transition: all 0.3s ease;
}

.user-modal .modal-header .btn-close:hover {
  background-color: rgba(255, 255, 255, 0.8);
  transform: scale(1.1);
}

.user-modal .modal-body {
  padding: 30px;
  background-color: #ffffff;
}

.user-modal .modal-body form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.user-modal .form-group {
  margin-bottom: 20px;
}

.user-modal label {
  display: block;
  color: #2b6777;
  font-weight: 500;
  margin-bottom: 8px;
}

.user-modal input[type="text"],
.user-modal input[type="password"] {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #c8d8e4;
  border-radius: 8px;
  background-color: #f2f2f2;
  color: #333;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.user-modal input[type="text"]:focus,
.user-modal input[type="password"]:focus {
  border-color: #52ab98;
  box-shadow: 0 0 0 3px rgba(82, 171, 152, 0.2);
  outline: none;
}

.user-modal .checkbox-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.user-modal .checkbox-container input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #52ab98;
}

.user-modal .form-button {
  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;
}

.user-modal .form-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(43, 103, 119, 0.2);
}

.user-modal .form-button:active {
  transform: translateY(0);
}

.user-modal .cancel-button {
  background-color: #f2f2f2;
  color: #2b6777;
  border: 2px solid #c8d8e4;
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.user-modal .cancel-button:hover {
  background-color: #c8d8e4;
}

.user-modal .modal-footer {
  border-top: none;
  padding: 16px 24px 24px;
  background-color: #ffffff;
}

/* Specific styles for Delete User Modal */
.delete-user-modal .modal-header {
  background: linear-gradient(135deg, #2b6777 0%, #e74c3c 80%);
}

.delete-user-modal .form-button {
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
}

.delete-user-modal .warning-text {
  color: #e74c3c;
  font-weight: 500;
  margin-bottom: 20px;
}

/* Animation for modals */
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: scale(0.9);
}

.modal.show .modal-dialog {
  transform: scale(1);
}

/* Report Modal Styles */
.report-section {
  margin-bottom: 1.25rem;
  padding: 1rem 1.25rem;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e9ecef;
}

.section-title {
  display: flex;
  align-items: center;
  margin-bottom: 1.25rem;
  color: #495057;
  font-weight: 600;
  font-size: 1.05rem;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 0.5rem;
}

.button-group {
  display: flex;
  gap: 0.75rem;
  margin-top: 0.75rem;
  flex-wrap: wrap;
}

.button-group .report-button {
  flex: 1 1;
  min-width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.6rem 1rem;
  background: #ffffff !important;
  color: black !important;
  border: 1px solid #0d6efd !important;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
}

.button-group .report-button:hover:not(.disabled) {
  background: #0d6efd !important;
  color: #ffffff !important;
  box-shadow: 0 2px 8px rgba(13, 110, 253, 0.25);
}

.button-group .report-button.disabled {
  background: #f1f3f5 !important;
  color: #868e96;
  border-color: #dee2e6;
  cursor: not-allowed;
}

.option-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
  margin-top: 0.75rem;
}

.option-card {
  background: #ffffff !important;
  color: #212529 !important;
  border: 1px solid #e9ecef;
  border-radius: 10px;
  padding: 1rem 1.25rem;
  text-align: left;
  transition: box-shadow 0.2s ease, transform 0.1s ease, border-color 0.2s ease;
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  gap: 0.875rem;
  min-height: 96px;
}

.option-card:hover {
  border-color: #cfd8e3;
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(33, 37, 41, 0.08);
}

.option-icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  background: #eef4ff;
  border: 1px solid #dee6ff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0d6efd;
}

.option-content h6 {
  margin: 0 0 0.35rem 0;
  font-weight: 600;
  color: #212529;
  font-size: 1rem;
}

.option-content p {
  margin: 0;
  color: #6c757d;
  font-size: 0.9rem;
  line-height: 1.4;
}

@media (max-width: 768px) {
  .option-grid { grid-template-columns: 1fr; }
  .button-group { flex-direction: column; }
  .button-group .report-button { min-width: auto; }
}
.report-modal .modal-content {
  border-radius: 16px;
  border: none;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.report-modal .modal-header {
  background: linear-gradient(135deg, #2b6777, #52ab98);
  color: white;
  border-bottom: none;
  padding: 20px 25px;
}

.report-modal .modal-title {
  font-weight: 600;
  font-size: 1.2rem;
}

.report-modal .modal-body {
  padding: 25px;
  background-color: #ffffff;
}

.report-modal .form-group {
  margin-bottom: 20px;
}

.report-modal .form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #2b6777;
}

.report-modal .dropdown button {
  background-color: #f2f2f2;
  border: 1px solid #c8d8e4;
  border-radius: 8px;
  padding: 10px 15px;
  width: 100%;
  text-align: left;
  color: #333;
  transition: all 0.3s ease;
}

.report-modal .dropdown button:hover,
.report-modal .dropdown button:focus {
  background-color: #e8f0f5;
  border-color: #52ab98;
}

.report-modal .dropdown-menu {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
}

.report-modal .dropdown-item {
  padding: 10px 15px;
  transition: background-color 0.2s;
}

.report-modal .dropdown-item:hover {
  background-color: #e8f0f5;
  color: #2b6777;
}

.report-modal .form-control {
  border-radius: 8px;
  padding: 12px 15px;
  border: 1px solid #c8d8e4;
  transition: all 0.3s ease;
}

.report-modal .form-control:focus {
  border-color: #52ab98;
  box-shadow: 0 0 0 3px rgba(82, 171, 152, 0.25);
}

.report-modal .option-container {
  display: flex;
  gap: 15px;
  margin-top: 15px;
  flex-wrap: wrap;
}

.report-modal .option-button {
  background: linear-gradient(to bottom, #f2f2f2, #e6e6e6);
  color: #2b6777;
  border: 1px solid #c8d8e4;
  border-radius: 8px;
  padding: 10px 20px;
  flex: 1 1;
  min-width: 120px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.report-modal .option-button:hover {
  background: linear-gradient(to bottom, #e6e6e6, #d9d9d9);
  border-color: #2b6777;
  transform: translateY(-2px);
}

.report-modal .report-button {
  background: linear-gradient(135deg, #2b6777, #52ab98);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-weight: 500;
  width: 100%;
  margin-top: 10px;
  transition: all 0.3s ease;
}

.report-modal .report-button:hover:not(.disabled) {
  background: linear-gradient(135deg, #245a67, #479e8c);
  box-shadow: 0 4px 12px rgba(43, 103, 119, 0.3);
  transform: translateY(-2px);
}

.report-modal .report-button.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #a0a0a0;
}

.report-modal .form-button {
  background-color: #52ab98;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-weight: 500;
  width: 100%;
  transition: all 0.3s ease;
}

.report-modal .form-button:hover {
  background-color: #479e8c;
  box-shadow: 0 4px 12px rgba(82, 171, 152, 0.3);
}

.report-modal .cancel-button {
  background-color: transparent;
  color: #2b6777;
  border: 1px solid #c8d8e4;
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.report-modal .cancel-button:hover {
  background-color: #f2f2f2;
  border-color: #2b6777;
}

.report-modal .modal-footer {
  border-top: 1px solid #f2f2f2;
  padding: 15px 25px;
}

/* AI Report entry hub (Admin) — not \`.report-modal\` so header/tiles are not forced to report styles */
.ai-report-hub-modal .modal-content {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 16px 48px rgba(15, 45, 55, 0.18);
}

.ai-report-hub-modal-header {
  background: linear-gradient(135deg, #2b6777 0%, #3a7a8c 45%, #52ab98 100%);
  color: #fff;
  border-bottom: none;
  padding: 1.35rem 1.5rem 1.25rem;
}

.ai-report-hub-modal .modal-title {
  color: #fff;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.ai-report-hub-modal-subtitle {
  color: rgba(255, 255, 255, 0.88);
  line-height: 1.45;
  max-width: 36rem;
}

.ai-report-hub-modal-body {
  padding: 1.75rem 1.5rem 2rem;
  background: linear-gradient(180deg, #f5f9f8 0%, #eef4f3 100%);
}

.ai-report-hub-tile {
  position: relative;
  height: 100%;
  min-height: 176px;
  padding: 1.5rem 1.35rem 1.4rem;
  border-radius: 16px;
  border: 1px solid #d5e2e6;
  background: #fff;
  box-shadow: 0 4px 14px rgba(43, 103, 119, 0.06);
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    box-shadow 0.22s ease,
    transform 0.18s ease,
    background 0.2s ease;
  outline: none;
}

.ai-report-hub-tile:hover {
  border-color: #52ab98;
  box-shadow: 0 14px 36px rgba(43, 103, 119, 0.14);
  transform: translateY(-3px);
  background: #fff;
}

.ai-report-hub-tile:focus-visible {
  outline: 3px solid rgba(82, 171, 152, 0.55);
  outline-offset: 3px;
}

.ai-report-hub-tile:active {
  transform: translateY(-1px);
}

.ai-report-hub-tile--accent {
  border-color: #c5d8de;
  background: linear-gradient(165deg, #ffffff 0%, #f0faf7 55%, #e8f5f1 100%);
}

.ai-report-hub-tile--accent:hover {
  background: #fff;
}

.ai-report-hub-tile-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  background: linear-gradient(145deg, #2b6777, #52ab98);
  color: #fff;
  font-size: 1.2rem;
  box-shadow: 0 6px 16px rgba(43, 103, 119, 0.25);
}

.ai-report-hub-tile--accent .ai-report-hub-tile-icon {
  background: linear-gradient(145deg, #1f5566, #449e8a);
}

.ai-report-hub-tile-title {
  font-size: 1.15rem;
  font-weight: 650;
  color: #1a3d47;
  margin: 0 0 0.5rem;
  letter-spacing: 0.01em;
}

.ai-report-hub-tile-desc {
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.55;
  color: #4a5f66;
}

/* AI Modal Styles */
.ai-modal .modal-content {
  border-radius: 16px;
  border: none;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.ai-modal .modal-header {
  background: linear-gradient(135deg, #2b6777, #52ab98);
  color: white;
  border-bottom: none;
  padding: 20px 25px;
}

.ai-modal .modal-title {
  font-weight: 600;
  font-size: 1.2rem;
}

.ai-modal .modal-body {
  padding: 20px;
  background-color: #ffffff;
  max-height: 70vh;
  overflow-y: auto;
}

.ai-modal .dropdown-toggle {
  background-color: #f2f2f2;
  border: 1px solid #c8d8e4;
  border-radius: 8px;
  padding: 10px 15px;
  text-align: left;
  color: #333;
  transition: all 0.3s ease;
  margin-bottom: 15px;
  width: 100%;
  max-width: 300px;
}

.ai-modal .dropdown-toggle:hover,
.ai-modal .dropdown-toggle:focus {
  background-color: #e8f0f5;
  border-color: #52ab98;
}

.ai-modal .form-group {
  margin-bottom: 20px;
}

.ai-modal .form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #2b6777;
}

.ai-modal .form-control {
  border-radius: 8px;
  padding: 12px 15px;
  border: 1px solid #c8d8e4;
  transition: all 0.3s ease;
}

.ai-modal .form-control:focus {
  border-color: #52ab98;
  box-shadow: 0 0 0 3px rgba(82, 171, 152, 0.25);
  outline: none;
}

.ai-modal .chat-container {
  background-color: #f7f9fc;
  border-radius: 12px;
  padding: 15px;
  margin: 20px 0;
  max-height: 350px;
  overflow-y: auto;
}

.ai-modal .message {
  margin-bottom: 15px;
  max-width: 85%;
  animation: fadeIn 0.3s ease-in-out;
  position: relative;
}

.ai-modal .user-message {
  background: linear-gradient(135deg, #2b6777, #52ab98);
  color: white;
  border-radius: 12px 12px 0 12px;
  padding: 12px 16px;
  margin-left: auto;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.ai-modal .ai-message {
  background-color: #e8f1f4;
  border-radius: 12px 12px 12px 0;
  padding: 12px 16px;
  margin-right: auto;
  color: #333;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.ai-modal .error {
  background-color: #ffebee;
  color: #e74c3c;
  border-radius: 12px;
  padding: 12px 16px;
  margin: 10px auto;
  text-align: center;
  border: 1px solid rgba(231, 76, 60, 0.3);
  max-width: 90%;
}

.ai-modal .loading {
  background-color: transparent;
  box-shadow: none;
  display: flex;
  justify-content: center;
  margin: 15px auto;
}

.ai-modal .message-content {
  word-break: break-word;
}

.ai-modal .message-content p {
  margin: 0;
}

.ai-modal .status {
  font-size: 11px;
  display: flex;
  align-items: center;
  margin-top: 5px;
  opacity: 0.8;
}

.ai-modal .user-message .status {
  justify-content: flex-end;
}

.ai-modal .ai-message .status {
  justify-content: flex-start;
}

.ai-modal .input-container {
  display: flex;
  padding: 15px 0;
  gap: 10px;
  margin-top: 20px;
}

.ai-modal .message-input {
  flex: 1 1;
  border: 1px solid #c8d8e4;
  border-radius: 24px;
  padding: 12px 20px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.ai-modal .message-input:focus {
  outline: none;
  border-color: #52ab98;
  box-shadow: 0 0 0 3px rgba(82, 171, 152, 0.25);
}

.ai-modal .send-button {
  background: linear-gradient(135deg, #2b6777, #52ab98);
  color: white;
  border: none;
  border-radius: 50%;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.ai-modal .send-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #245a67, #479e8c);
  transform: scale(1.05);
}

.ai-modal .send-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.ai-modal .modal-footer {
  border-top: 1px solid #f2f2f2;
  padding: 15px 25px;
}

.ai-modal .clear-button {
  background-color: transparent;
  color: #2b6777;
  border: 1px solid #c8d8e4;
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.ai-modal .clear-button:hover {
  background-color: #f2f2f2;
  border-color: #2b6777;
}

.ai-modal .cancel-button {
  background-color: transparent;
  color: #2b6777;
  border: 1px solid #c8d8e4;
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.ai-modal .cancel-button:hover {
  background-color: #f2f2f2;
  border-color: #2b6777;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Temporal Activity Modal Styles */
.temporal-modal .modal-content {
  border-radius: 16px;
  border: none;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.temporal-modal .modal-header {
  background: linear-gradient(135deg, #2b6777, #52ab98);
  color: white;
  border-bottom: none;
  padding: 20px 25px;
}

.temporal-modal .modal-title {
  font-weight: 600;
  font-size: 1.2rem;
}

.temporal-modal .modal-body {
  padding: 25px;
  background-color: #ffffff;
}

.temporal-modal .form-group {
  margin-bottom: 20px;
}

.temporal-modal .form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #2b6777;
}

.temporal-modal .dropdown-toggle {
  background-color: #f2f2f2;
  border: 1px solid #c8d8e4;
  border-radius: 8px;
  padding: 10px 15px;
  text-align: left;
  color: #333;
  transition: all 0.3s ease;
  min-width: 200px;
}

.temporal-modal .dropdown-toggle:hover,
.temporal-modal .dropdown-toggle:focus {
  background-color: #e8f0f5;
  border-color: #52ab98;
}

.temporal-modal .dropdown-menu {
  max-height: 300px;
  overflow-y: auto;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
}

.temporal-modal .dropdown-item {
  padding: 10px 15px;
  transition: background-color 0.2s;
}

.temporal-modal .dropdown-item:hover {
  background-color: #e8f0f5;
  color: #2b6777;
}

.temporal-modal .action-button {
  background: linear-gradient(135deg, #2b6777, #52ab98);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 500;
  transition: all 0.3s ease;
  margin-right: 10px;
}

.temporal-modal .action-button:hover:not(:disabled) {
  background: linear-gradient(135deg, #245a67, #479e8c);
  box-shadow: 0 4px 12px rgba(43, 103, 119, 0.3);
  transform: translateY(-2px);
}

.temporal-modal .action-button:disabled {
  background: #a0a0a0;
  cursor: not-allowed;
  opacity: 0.6;
}

.temporal-modal .secondary-button {
  background-color: #f2f2f2;
  color: #2b6777;
  border: 1px solid #c8d8e4;
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 500;
  transition: all 0.3s ease;
  margin-right: 10px;
}

.temporal-modal .secondary-button:hover {
  background-color: #e8f0f5;
  border-color: #2b6777;
}

.temporal-modal .modal-footer {
  border-top: 1px solid #f2f2f2;
  padding: 15px 25px;
}

.temporal-modal .form-control {
  border-radius: 8px;
  padding: 12px 15px;
  border: 1px solid #c8d8e4;
  transition: all 0.3s ease;
}

.temporal-modal .form-control:focus {
  border-color: #52ab98;
  box-shadow: 0 0 0 3px rgba(82, 171, 152, 0.25);
  outline: none;
}

.temporal-modal .tracking-options {
  display: flex;
  gap: 15px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.temporal-modal .button-container {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

/* Dashboard Styles */
.dashboard-modal .modal-content {
  border-radius: 16px;
  border: none;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.dashboard-modal .modal-body {
  padding: 25px;
}

.dashboard-modal .modal-xl {
  max-width: 96%;
  margin: 20px auto;
}

.dashboard-modal .table-container {
  max-height: 65vh;
  overflow-y: auto;
  margin-top: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
}

.dashboard-modal .table {
  margin-bottom: 0;
}

.dashboard-modal .table th {
  position: sticky;
  top: 0;
  background-color: #f8f9fa;
  z-index: 10;
  padding: 15px 10px;
  border-bottom: 2px solid #dee2e6;
  color: #2b6777;
  font-weight: 600;
}

.dashboard-modal .table td {
  padding: 12px 10px;
  vertical-align: middle;
}

.dashboard-modal .table-striped > tbody > tr:nth-of-type(odd) {
  background-color: rgba(200, 216, 228, 0.1);
}

.dashboard-modal .table-bordered {
  border: 1px solid #e0e0e0;
}

.dashboard-modal .table-bordered td, 
.dashboard-modal .table-bordered th {
  border: 1px solid #e0e0e0;
}

.dashboard-modal .form-inline {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
}

/* Activity Results Modal */
.activity-results-modal .modal-body {
  max-height: 70vh;
  overflow-y: auto;
}

.activity-results-modal .table-container {
  overflow-x: auto;
  margin-top: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.activity-results-modal table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0;
}

.activity-results-modal th {
  background-color: #f5f7f8;
  color: #2b6777;
  font-weight: 600;
  padding: 12px 16px;
  text-align: left;
}

.activity-results-modal td {
  padding: 12px 16px;
  border-top: 1px solid #eaeaea;
}

.activity-results-modal tr:hover {
  background-color: rgba(200, 216, 228, 0.1);
}

/* Upload Sheets Modal */
.upload-modal .modal-body {
  padding: 30px;
}

.upload-modal .form-label {
  color: #2b6777;
  font-weight: 500;
  margin-bottom: 8px;
}

.upload-modal .form-control {
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #c8d8e4;
}

.upload-modal .upload-button {
  background: linear-gradient(135deg, #2b6777, #52ab98);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-weight: 500;
  width: 100%;
  margin-top: 20px;
  transition: all 0.3s ease;
}

.upload-modal .upload-button:hover {
  background: linear-gradient(135deg, #245a67, #479e8c);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(43, 103, 119, 0.3);
}

.upload-modal .results-container {
  background-color: #f7f9fc;
  border-radius: 8px;
  padding: 20px;
  margin-top: 20px;
  border-left: 4px solid #52ab98;
}

/* App-wide modal backdrop blur (matches Admin Upload Sheets) */
.modal-backdrop,
.admin-motion-blur-backdrop,
.employee-panel-overlay-backdrop {
  background: rgba(15, 23, 42, 0.35) !important;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

/* Upload Sheets — custom overlay (replaces Bootstrap .modal-backdrop) */
.admin-motion-blur-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1050;
}

.admin-upload-sheets-modal {
  z-index: 1055;
}

/* Employee Panel Styles */
.employee-task-modal .modal-content {
  border: none;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(43, 103, 119, 0.2);
  overflow: hidden;
}

.employee-task-modal .modal-header {
  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
  color: #ffffff;
  padding: 1.25rem 1.5rem;
  border-bottom: none;
}

.employee-task-modal .modal-title {
  font-weight: 600;
  font-size: 1.25rem;
}

.employee-task-modal .modal-header .btn-close {
  color: #ffffff;
  opacity: 0.8;
  transition: all 0.3s ease;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/1em auto no-repeat;
}

.employee-task-modal .modal-header .btn-close:hover {
  opacity: 1;
  transform: rotate(90deg);
}

.employee-task-modal .modal-body {
  padding: 1.5rem;
  background-color: #ffffff;
}

.employee-task-modal form {
  display: flex;
  flex-direction: column;
}

.employee-task-modal .mb-3 {
  margin-bottom: 1.25rem !important;
}

.employee-task-modal .form-label {
  font-weight: 500;
  color: #2b6777;
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
}

.employee-task-modal .form-label.text-red {
  color: #e74c3c;
}

.employee-task-modal input[type="text"],
.employee-task-modal input[type="number"],
.employee-task-modal textarea,
.employee-task-modal select,
.employee-task-modal .react-datepicker-wrapper {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid #c8d8e4;
  border-radius: 8px;
  font-size: 0.95rem;
  background-color: #f2f2f2;
  transition: all 0.3s ease;
}

.employee-task-modal input[type="text"]:focus,
.employee-task-modal input[type="number"]:focus,
.employee-task-modal textarea:focus,
.employee-task-modal select:focus,
.employee-task-modal .form-control:focus {
  outline: none;
  border-color: #52ab98;
  box-shadow: 0 0 0 3px rgba(82, 171, 152, 0.2);
  background-color: #ffffff;
}

.employee-task-modal input[type="text"]::placeholder,
.employee-task-modal input[type="number"]::placeholder,
.employee-task-modal textarea::placeholder {
  color: #8a9ca8;
}

.employee-task-modal input[type="text"]:disabled,
.employee-task-modal input[type="number"]:disabled {
  background-color: #e9ecef;
  cursor: not-allowed;
  opacity: 0.8;
}

.employee-task-modal select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  appearance: none;
}

.employee-task-modal textarea {
  min-height: 100px;
  resize: vertical;
}

.employee-task-modal .btn {
  border-radius: 8px;
  font-weight: 500;
  padding: 0.75rem 1.5rem;
  transition: all 0.3s ease;
}

.employee-task-modal .btn-primary {
  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
  border: none;
  color: white;
}

.employee-task-modal .btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(43, 103, 119, 0.2);
}

.employee-task-modal .btn-primary:active {
  transform: translateY(0);
}

.employee-task-modal .btn-secondary {
  background-color: #c8d8e4;
  border: none;
  color: #2b6777;
}

.employee-task-modal .btn-secondary:hover {
  background-color: #b6c9d8;
  color: #2b6777;
}

.employee-task-modal .position-relative {
  position: relative;
}

.employee-task-modal .btn-sm {
  padding: 0.4rem 0.75rem;
  font-size: 0.875rem;
}

.employee-task-modal .spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

.employee-task-modal .modal-footer {
  background-color: #f8f9fa;
  border-top: 1px solid #eaeaea;
  padding: 1rem 1.5rem;
}

/* Add / Edit job modals: polished “sheet” layout */
.employee-task-modal .employee-job-form-sheet {
  border-radius: 18px;
  overflow: hidden;
  box-shadow:
    0 4px 6px rgba(43, 103, 119, 0.04),
    0 22px 50px rgba(25, 78, 92, 0.18);
}

.employee-task-modal .employee-job-form-modal-header {
  position: relative;
  background: linear-gradient(118deg, #1f5566 0%, #2b6777 38%, #3d9a87 100%);
  color: #fff;
  border-bottom: none;
  padding-top: 1.35rem;
  padding-bottom: 1.35rem;
  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.12);
}

.employee-task-modal .employee-job-form-modal-header::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3px;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.45) 0%,
    rgba(255, 255, 255, 0.08) 45%,
    transparent 100%
  );
  pointer-events: none;
}

.employee-task-modal .employee-job-form-modal-header .modal-title {
  color: #fff;
  letter-spacing: -0.02em;
}

.employee-task-modal .employee-job-form-header-sub {
  font-size: 0.8125rem;
  line-height: 1.35;
  color: rgba(255, 255, 255, 0.78);
  font-weight: 400;
  max-width: 36rem;
}

.employee-task-modal .employee-job-form-sheet .modal-body {
  background: linear-gradient(180deg, #e8f2f0 0%, #f0f6f5 22%, #f7faf9 55%, #ffffff 100%);
  padding: 1.5rem 1.65rem 1.35rem;
}

.employee-task-modal .employee-job-form {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.employee-task-modal .employee-job-form-section {
  background: #ffffff;
  border: 1px solid rgba(43, 103, 119, 0.1);
  border-radius: 14px;
  padding: 1.25rem 1.35rem 1.35rem;
  margin-bottom: 1rem;
  box-shadow:
    0 1px 2px rgba(43, 103, 119, 0.04),
    0 8px 24px rgba(43, 103, 119, 0.06);
}

.employee-task-modal .employee-job-form-section:last-of-type {
  margin-bottom: 0;
}

.employee-task-modal .employee-job-form-section-title {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #245a6a;
  margin-bottom: 1rem;
  padding-bottom: 0.65rem;
  border-bottom: 1px solid rgba(82, 171, 152, 0.22);
}

.employee-task-modal .employee-job-form-section-title::before {
  content: "";
  flex-shrink: 0;
  width: 4px;
  height: 14px;
  border-radius: 3px;
  background: linear-gradient(180deg, #52ab98 0%, #2b6777 100%);
  box-shadow: 0 1px 3px rgba(43, 103, 119, 0.35);
}

/* Inputs inside job sheet: cleaner than default modal grey */
.employee-task-modal .employee-job-form-sheet input[type="text"],
.employee-task-modal .employee-job-form-sheet input[type="number"],
.employee-task-modal .employee-job-form-sheet textarea,
.employee-task-modal .employee-job-form-sheet select,
.employee-task-modal .employee-job-form-sheet .react-datepicker-wrapper .form-control {
  background-color: #fbfdfe;
  border-color: #c5d8e0;
  box-shadow: inset 0 1px 2px rgba(43, 103, 119, 0.035);
}

.employee-task-modal .employee-job-form-sheet input[type="text"]:hover,
.employee-task-modal .employee-job-form-sheet input[type="number"]:hover,
.employee-task-modal .employee-job-form-sheet textarea:hover,
.employee-task-modal .employee-job-form-sheet select:hover {
  border-color: #a8c5d2;
}

.employee-task-modal .employee-job-form-sheet .form-select {
  background-color: #fbfdfe;
  border-color: #c5d8e0;
}

.employee-task-modal .employee-job-form-sheet .form-text {
  color: #5a7585;
  font-size: 0.8125rem;
}

.employee-task-modal .employee-job-form-desc-wrap {
  margin-bottom: 1.1rem !important;
}

.employee-task-modal .employee-job-form-desc-toolbar {
  margin-bottom: 0.5rem;
}

.employee-task-modal .employee-job-form-desc-inner {
  padding: 0.65rem 0.65rem 0.65rem;
  background: linear-gradient(180deg, #f4faf9 0%, #fbfdfe 100%);
  border: 1px solid rgba(82, 171, 152, 0.2);
  border-radius: 12px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.85);
}

.employee-task-modal .employee-job-form-desc-inner .employee-job-form-textarea,
.employee-task-modal .employee-job-form-desc-inner textarea.form-control {
  background: #ffffff;
  border-color: #c5d8e0;
  border-radius: 10px;
}

.employee-task-modal .employee-job-form-textarea {
  min-height: 8rem;
  resize: vertical;
}

.employee-task-modal .employee-job-form-ai-btn {
  border-radius: 999px;
  padding: 0.45rem 0.95rem;
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  box-shadow:
    0 2px 8px rgba(43, 103, 119, 0.22),
    0 1px 0 rgba(255, 255, 255, 0.2) inset;
}

.employee-task-modal .employee-job-form-ai-btn:disabled {
  opacity: 0.55;
  transform: none;
  box-shadow: none;
}

.employee-task-modal .employee-github-link-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  align-items: center;
  min-height: 2.45rem;
  padding: 0.3rem 0.5rem;
  border: 1px solid #c5d8e0;
  border-radius: 10px;
  background: #ffffff;
}

.employee-task-modal .employee-github-link-tags:focus-within {
  border-color: #2b6777;
  box-shadow: 0 0 0 0.2rem rgba(43, 103, 119, 0.18);
}

.employee-task-modal .employee-github-link-tags-entry {
  display: flex;
  flex: 1 1 10rem;
  align-items: center;
  gap: 0.45rem;
  min-width: 0;
}

.employee-task-modal .employee-github-link-tags-entry .employee-github-link-tags-input {
  flex: 1 1 auto;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  padding: 0.25rem 0.2rem;
  font-size: 0.9375rem;
}

.employee-task-modal .employee-github-link-tags-add-btn {
  flex-shrink: 0;
  white-space: nowrap;
  font-weight: 600;
  border-radius: 8px;
  padding-inline: 0.55rem;
}

.employee-task-modal .employee-github-link-tag {
  max-width: 100%;
  font-weight: 500;
  font-size: 0.8125rem;
  padding: 0.35rem 0.35rem 0.35rem 0.5rem;
}

.employee-task-modal .employee-job-form-actions {
  margin-top: 0.25rem;
  padding: 1rem 1.2rem !important;
  border-radius: 12px;
  border: 1px solid rgba(43, 103, 119, 0.1) !important;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 4px 20px rgba(43, 103, 119, 0.07);
}

.employee-task-modal .employee-job-form-actions .btn-primary {
  min-width: 10.5rem;
  border-radius: 10px;
  padding-top: 0.65rem;
  padding-bottom: 0.65rem;
  font-weight: 600;
}

.employee-task-modal .employee-job-form-sheet .modal-footer {
  background: linear-gradient(180deg, #f2f8f7 0%, #e8f0ef 100%);
  border-top: 1px solid rgba(43, 103, 119, 0.12);
  padding: 0.9rem 1.65rem;
}

.employee-task-modal .employee-job-form-sheet .modal-footer .btn-secondary {
  border-radius: 10px;
  font-weight: 500;
}

/* Employee panel tables */
.employee-panel .table {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(43, 103, 119, 0.08);
  border-collapse: separate;
  border-spacing: 0;
}

.employee-panel .table thead th {
  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
  color: #ffffff;
  font-weight: 500;
  border: none;
  padding: 0.75rem 1rem;
  position: sticky;
  top: 0;
  z-index: 10;
}

.employee-panel .table tbody td {
  padding: 0.75rem 1rem;
  border-top: none;
  border-bottom: 1px solid #e9ecef;
  vertical-align: middle;
}

.employee-panel .table-light {
  --bs-table-bg: transparent;
}

.employee-panel .table tbody tr:last-child td {
  border-bottom: none;
}

.employee-panel .table tbody tr:hover {
  background-color: rgba(200, 216, 228, 0.15);
}

.employee-panel .badge {
  font-weight: 500;
  padding: 0.5em 0.75em;
  border-radius: 6px;
  font-size: 0.8rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s ease;
}

.employee-panel .badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.employee-panel .badge.text-bg-primary {
  background-color: #2b6777 !important;
}

.employee-panel .badge.text-bg-success {
  background-color: #52ab98 !important;
}

.employee-panel .badge.text-bg-warning {
  background-color: #f9bc60 !important;
  color: #343a40 !important;
}

.employee-panel .badge.text-bg-danger {
  background-color: #e74c3c !important;
}

.employee-panel .badge.text-bg-secondary {
  background-color: #6c757d !important;
}

.employee-panel .search-bar {
  margin-bottom: 1.5rem;
}

.employee-panel .search-bar .form-control {
  border-radius: 8px;
  padding: 0.75rem 1.25rem;
  border: 1px solid #c8d8e4;
  background-color: #f2f2f2;
  transition: all 0.3s ease;
}

.employee-panel .search-bar .form-control:focus {
  border-color: #52ab98;
  box-shadow: 0 0 0 3px rgba(82, 171, 152, 0.2);
  background-color: #ffffff;
}

.employee-panel .card-header {
  background: transparent;
  border-bottom: none;
  padding: 1.25rem 0;
}

.employee-panel .card-header .heading h2 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2b6777;
  margin: 0;
}

.employee-panel .card-header .btn-primary {
  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.employee-panel .card-header .btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(43, 103, 119, 0.2);
}

@media (max-width: 767.98px) {
  .employee-panel .card-header .employee-jobs-add-btn {
    width: 100%;
  }
}

.employee-panel .header {
  padding: 1.5rem 0;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 1.5rem;
}

.employee-panel .header h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #2b6777;
  margin: 0;
}

.employee-panel .header .btn-danger {
  background-color: #e74c3c;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.employee-panel .header .btn-danger:hover {
  background-color: #c0392b;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(231, 76, 60, 0.2);
}

/* Employee workspace tabs — matches panel header / teal theme */
.employee-panel .employee-tabs-bar {
  padding: 0 0 1.25rem;
  margin-bottom: 0.25rem;
  border-bottom: 1px solid #e9ecef;
}

.employee-panel .employee-tabs-bar-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem 1.5rem;
}

.employee-panel .employee-tabs-heading {
  flex: 1 1 200px;
  min-width: 0;
}

.employee-panel .employee-tabs-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2b6777;
  margin: 0 0 0.2rem;
  letter-spacing: -0.02em;
}

.employee-panel .employee-tabs-subtitle {
  margin: 0;
  font-size: 0.9rem;
  color: #6c757d;
  font-weight: 400;
  line-height: 1.4;
  max-width: 36rem;
}

.employee-panel .employee-tabs-group {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
  background: linear-gradient(180deg, #f5faf9 0%, #eef4f4 100%);
  padding: 0.4rem;
  border-radius: 10px;
  border: 1px solid #dce8e6;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.85),
    0 2px 8px rgba(43, 103, 119, 0.06);
}

.employee-panel .employee-tab-btn {
  border: none;
  background: transparent;
  color: #2b6777;
  font-weight: 600;
  font-size: 0.9rem;
  padding: 0.65rem 1.25rem;
  border-radius: 8px;
  cursor: pointer;
  transition:
    color 0.2s ease,
    background 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.15s ease;
  white-space: nowrap;
}

.employee-panel .employee-tab-btn:hover:not(.active) {
  background: rgba(255, 255, 255, 0.75);
  color: #1e4d5a;
}

.employee-panel .employee-tab-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(82, 171, 152, 0.45);
}

.employee-panel .employee-tab-btn.active {
  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
  color: #ffffff;
  box-shadow: 0 4px 14px rgba(43, 103, 119, 0.28);
}

.employee-panel .employee-tab-btn.active:hover {
  color: #ffffff;
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(43, 103, 119, 0.32);
}

/* Let wide tables scroll: fluid columns default to min-content and clip overflow */
.employee-panel > .container-fluid,
.employee-panel .employee-workspace {
  min-width: 0;
  max-width: 100%;
}

.employee-panel .employee-tabs-panel {
  padding-top: 0.35rem;
  animation: employee-tab-fade 0.22s ease-out;
  min-width: 0;
  max-width: 100%;
}

@keyframes employee-tab-fade {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 576px) {
  .employee-panel .employee-tabs-bar-row {
    flex-direction: column;
    align-items: stretch;
  }

  .employee-panel .employee-tabs-group {
    justify-content: stretch;
  }

  .employee-panel .employee-tab-btn {
    flex: 1 1;
    text-align: center;
    padding: 0.6rem 0.75rem;
  }
}

.employee-panel .text-green {
  color: #52ab98 !important;
}

.employee-panel .text-truncate {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Jobs table: responsive scroll, compact type, clip + tooltip cells */
.employee-panel .employee-jobs-table-responsive,
.employee-panel .employee-subjobs-table-responsive,
.employee-panel .employee-logged-hours-table-responsive {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
}

.employee-panel .employee-jobs-table-responsive {
  -webkit-overflow-scrolling: touch;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(43, 103, 119, 0.08);
}

.employee-panel .table.employee-jobs-table {
  font-size: 0.8125rem;
  min-width: 760px;
  margin-bottom: 0;
  --jobs-row-border: #e8edf2;
  --jobs-row-stripe: #f6f8fa;
  background-color: #fff;
  border: 1px solid #dde5ec;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 10px;
  overflow: hidden;
}

.employee-panel .table.employee-jobs-table thead th {
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: none;
  padding: 0.65rem 0.75rem;
  vertical-align: middle;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  white-space: nowrap;
}

.employee-panel .table.employee-jobs-table thead th.jobs-th-primary {
  text-align: left;
}

.employee-panel .table.employee-jobs-table thead th.jobs-th-num {
  text-align: center;
  width: 4.25rem;
  max-width: 4.5rem;
}

.employee-panel .table.employee-jobs-table thead th.jobs-th-date {
  text-align: center;
}

.employee-panel .table.employee-jobs-table thead th.jobs-th-status {
  text-align: center;
  width: 6.5rem;
}

.employee-panel .table.employee-jobs-table tbody td.jobs-td-status {
  text-align: center;
}

.employee-panel .table.employee-jobs-table thead th.jobs-th-github {
  text-align: center;
}

.employee-panel .table.employee-jobs-table thead th.jobs-th-actions {
  text-align: center;
  width: 1%;
}

.employee-panel .table.employee-jobs-table tbody td {
  padding: 0.6rem 0.75rem;
  vertical-align: middle;
  border-bottom: 1px solid var(--jobs-row-border);
  color: #334155;
}

.employee-panel .table.employee-jobs-table tbody tr:nth-child(even) td {
  background-color: var(--jobs-row-stripe);
}

.employee-panel .table.employee-jobs-table tbody tr:hover td {
  background-color: rgba(200, 216, 228, 0.35) !important;
}

.employee-panel .table.employee-jobs-table tbody tr:last-child td {
  border-bottom: none;
}

.employee-panel .table.employee-jobs-table tbody td:nth-child(1),
.employee-panel .table.employee-jobs-table tbody td:nth-child(2) {
  text-align: left;
}

.employee-panel .table.employee-jobs-table tbody td.jobs-td-num {
  text-align: center;
  font-variant-numeric: tabular-nums;
  font-weight: 500;
  color: #475569;
  width: 4.25rem;
}

.employee-panel .table.employee-jobs-table tbody td.jobs-td-date {
  text-align: center;
  font-variant-numeric: tabular-nums;
  color: #475569;
}

.employee-panel .table.employee-jobs-table tbody td:nth-child(2) .jobs-clip-text {
  font-weight: 500;
  color: #1e293b;
}

.employee-panel .table.employee-jobs-table tbody td:nth-child(2) .jobs-clip-wrap {
  max-width: min(14rem, 36vw);
}

.employee-panel .table.employee-jobs-table .badge {
  font-size: 0.7rem;
  padding: 0.35em 0.55em;
}

/* Jobs: search + status filter — row aligned to end (right) */
.employee-panel .employee-jobs-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem 1.25rem;
  width: 100%;
  max-width: min(44rem, 100%);
  margin-left: auto;
  margin-right: 0;
}

.employee-panel .employee-jobs-toolbar .employee-jobs-search-field {
  flex: 1 1 14rem;
  min-width: 0;
  max-width: 22rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.employee-panel .employee-jobs-toolbar .employee-jobs-toolbar-search-input {
  margin-bottom: 0;
  width: 100%;
}

.employee-panel .employee-jobs-toolbar .employee-jobs-status-filter {
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.5rem 0.65rem;
}

.employee-panel .employee-jobs-toolbar .employee-jobs-status-label {
  margin: 0;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #2b6777;
  line-height: 1.5;
  white-space: nowrap;
}

/* Toolbar select: forced theme so the current value (e.g. All) stays visible in all browsers */
.employee-panel .employee-jobs-toolbar .employee-jobs-toolbar-status-dropdown {
  margin-left: 0;
  min-width: 10.5rem;
  min-height: 2.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  padding: 0.45rem 2.25rem 0.45rem 0.75rem;
  color: #fff !important;
  -webkit-text-fill-color: #fff;
  background-color: #2b6777;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}),
    linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
  background-repeat: no-repeat, no-repeat;
  background-position: right 0.65rem center, center;
  background-size: 16px 16px, 100% 100%;
  border: 1px solid #1c3932;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(43, 103, 119, 0.12);
  line-height: 1.5;
}

.employee-panel .employee-logged-hours-search {
  width: 100%;
  max-width: 18rem;
  margin-left: auto;
}

@media (min-width: 576px) {
  .employee-panel .employee-jobs-toolbar {
    max-width: min(40rem, 100%);
  }

  .employee-panel .employee-logged-hours-search {
    max-width: 20rem;
  }
}

/* Clipped text + hover tooltip (scoped to jobs table) */
.employee-panel .table.employee-jobs-table .jobs-clip-wrap {
  position: relative;
  text-align: left;
}

.employee-panel .table.employee-jobs-table .jobs-clip-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.employee-panel .table.employee-jobs-table .jobs-client-cell .jobs-clip-wrap {
  max-width: min(7.5rem, 18vw);
}

.employee-panel .table.employee-jobs-table .jobs-desc-cell .jobs-clip-wrap {
  max-width: min(10rem, 22vw);
}

.employee-panel .table.employee-jobs-table .jobs-note-cell .jobs-clip-wrap {
  max-width: min(6.5rem, 16vw);
}

.employee-panel .table.employee-jobs-table .jobs-team-clip.jobs-clip-wrap {
  max-width: min(9.5rem, 20vw);
  margin-inline: auto;
}

.employee-panel .table.employee-jobs-table .jobs-tooltip-bubble {
  display: none;
  position: absolute;
  z-index: 1080;
  left: 50%;
  transform: translateX(-50%);
  top: calc(100% + 6px);
  min-width: min(100%, 12rem);
  max-width: min(420px, 85vw);
  max-height: 220px;
  overflow-y: auto;
  padding: 0.55rem 0.7rem;
  background: #1a3a42;
  color: #f8fafb;
  font-size: 0.8125rem;
  line-height: 1.45;
  border-radius: 8px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.22);
  white-space: pre-wrap;
  word-break: break-word;
  text-align: left;
  pointer-events: auto;
}

.employee-panel .table.employee-jobs-table .jobs-clip-wrap:hover .jobs-tooltip-bubble {
  display: block;
}

.employee-panel .table.employee-jobs-table .jobs-tooltip-bubble::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 100%;
  height: 8px;
}

.employee-panel .table.employee-jobs-table .jobs-tooltip-bubble::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -7px;
  border: 7px solid transparent;
  border-bottom-color: #1a3a42;
}

@media (hover: none) {
  .employee-panel .table.employee-jobs-table .jobs-tooltip-bubble {
    display: none !important;
  }
}

/* Pagination styling */
.employee-panel .pagination {
  margin-top: 1.5rem;
  display: flex;
  justify-content: center;
}

.employee-panel .pagination button {
  background-color: #f2f2f2;
  border: none;
  color: #2b6777;
  padding: 0.5rem 1rem;
  margin: 0 0.25rem;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.employee-panel .pagination button:hover:not(:disabled) {
  background-color: #c8d8e4;
}

.employee-panel .pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.employee-panel .pagination .active-page {
  background-color: #2b6777;
  color: white;
}

/* Employee table pagination (windowed pages + ellipsis) */
.employee-panel ul.pagination.employee-table-pagination {
  justify-content: flex-end;
  flex-wrap: wrap;
  row-gap: 0.35rem;
}

.employee-panel .employee-table-pagination .page-item .page-link {
  margin: 0;
  border-radius: 6px;
  min-width: 2.35rem;
  text-align: center;
}

.employee-panel .employee-table-pagination .page-item + .page-item {
  margin-left: 0.125rem;
}

.employee-panel .employee-table-pagination .page-link.active {
  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
  color: #fff;
  border-color: transparent;
  z-index: 1;
}

.employee-panel .employee-table-pagination .page-item.disabled .page-link {
  background-color: #f8f9fa;
  color: #6c757d;
  border-color: #dee2e6;
  opacity: 1;
}

.employee-panel .table.employee-jobs-table .jobs-actions-cell {
  text-align: center;
  width: 1%;
  white-space: nowrap;
}

.employee-panel .table.employee-jobs-table .jobs-actions-cell .badge {
  white-space: nowrap;
}

/* Actions pill — same gradient angle/colors as table header */
.employee-panel .table.employee-jobs-table .jobs-actions-toolbar {
  display: inline-flex;
  align-items: stretch;
  vertical-align: middle;
  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
  border: 1px solid rgba(30, 70, 80, 0.35);
  border-radius: 999px;
  box-shadow: 0 2px 8px rgba(43, 103, 119, 0.28);
  overflow: hidden;
}

.employee-panel .table.employee-jobs-table .jobs-actions-toolbar-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.35rem;
  min-height: 2.125rem;
  padding: 0.3rem 0.55rem;
  margin: 0;
  border: none;
  background: transparent;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.employee-panel .table.employee-jobs-table .jobs-actions-toolbar-btn + .jobs-actions-toolbar-btn {
  border-left: 1px solid rgba(255, 255, 255, 0.22);
}

.employee-panel .table.employee-jobs-table .jobs-actions-toolbar-btn:hover {
  background-color: rgba(255, 255, 255, 0.18);
  color: #fff;
}

.employee-panel .table.employee-jobs-table .jobs-actions-toolbar-btn:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.85);
  outline-offset: -2px;
  z-index: 1;
}

.employee-panel .table.employee-jobs-table .jobs-actions-toolbar-btn svg,
.employee-panel .table.employee-jobs-table .jobs-actions-toolbar-btn .iconify {
  flex-shrink: 0;
  display: block;
}

.employee-panel .table.employee-jobs-table .jobs-actions-toolbar-btn--delete {
  color: #fff;
}

.employee-panel .table.employee-jobs-table .jobs-actions-toolbar-btn--delete:hover {
  background-color: rgba(231, 76, 60, 0.35);
  color: #fff;
}

.employee-panel .table.employee-jobs-table .jobs-actions-toolbar-btn--status:hover {
  background-color: rgba(255, 255, 255, 0.22);
}

.employee-panel .table.employee-jobs-table .jobs-github-table-link {
  color: #2b6777;
  font-weight: 500;
}

.employee-panel .table.employee-jobs-table .jobs-github-table-link:hover {
  color: #52ab98;
}

/* Full-screen overlay for employee Jobs modals (not Bootstrap \`modal-backdrop\` — avoids global cleanup removing it). */
.employee-panel-overlay-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}

.employee-job-github-link-list li:last-child {
  margin-bottom: 0 !important;
}

/* Job detail panel (no full-page dimmer — close via X or Escape) */
.employee-job-detail-root {
  z-index: 1065;
}

/* GitHub AI summary (stacked above job detail overlay) */
.employee-github-ai-summary-backdrop {
  z-index: 1070;
}

.employee-github-ai-summary-modal-root {
  z-index: 1075;
}

.employee-github-ai-summary-header {
  background: linear-gradient(135deg, #1f5566 0%, #2b6777 42%, #3d9a87 100%);
}

.employee-github-ai-summary-body {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.6;
  color: #334148;
  border-color: #c8d8e4 !important;
  max-height: min(70vh, 28rem);
  overflow-y: auto;
}

.employee-job-detail-card {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 8px 28px rgba(43, 103, 119, 0.18);
}

.employee-job-detail-hero {
  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
}

.employee-job-detail-metrics {
  background-color: #f2f2f2;
  border-color: #e9ecef !important;
}

.employee-job-detail-section-title {
  color: #2b6777;
  letter-spacing: 0.03em;
}

.employee-job-detail-info-panel {
  padding: 1rem 1.15rem;
}

@media (min-width: 992px) {
  .employee-job-detail-info-panel {
    padding: 1.15rem 1.35rem;
  }
}

.employee-job-detail-stat-accent {
  color: #2b6777;
}

.employee-job-detail-inline-link {
  color: #2b6777;
  text-decoration: none;
}

.employee-job-detail-inline-link:hover {
  color: #52ab98;
  text-decoration: underline;
}

.employee-job-detail-label {
  min-width: 7.5rem;
}

.employee-job-detail-prose {
  max-height: 11rem;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.55;
  color: #495057;
  border-color: #c8d8e4 !important;
}

.employee-job-detail-stat {
  transition: box-shadow 0.15s ease, transform 0.15s ease;
  border-color: #e9ecef !important;
}

.employee-job-detail-stat:hover {
  box-shadow: 0 6px 16px rgba(43, 103, 119, 0.12) !important;
}

.employee-job-detail-modal-footer {
  background-color: #f8f9fa;
  border-top-color: #eaeaea !important;
}

/* Job detail modal: match other employee-task-modal buttons */
.employee-task-modal.employee-job-detail-card .modal-footer .btn-outline-secondary {
  border-color: #2b6777;
  color: #2b6777;
  background-color: #fff;
}

.employee-task-modal.employee-job-detail-card .modal-footer .btn-outline-secondary:hover {
  background-color: rgba(200, 216, 228, 0.4);
  border-color: #2b6777;
  color: #214e5a;
}

.employee-task-modal.employee-job-detail-card .modal-footer .btn-outline-danger {
  border-color: #e74c3c;
  color: #e74c3c;
}

.employee-task-modal.employee-job-detail-card .modal-footer .btn-outline-danger:hover {
  background-color: #e74c3c;
  border-color: #e74c3c;
  color: #fff;
}

.employee-task-modal.employee-job-detail-card .modal-footer .btn-secondary:disabled {
  opacity: 0.45;
}

.employee-task-modal.employee-job-detail-card .modal-footer .employee-job-detail-action-btn {
  min-height: 2.75rem;
}

.employee-task-modal.employee-job-detail-card .modal-footer .employee-job-detail-action-btn svg,
.employee-task-modal.employee-job-detail-card .modal-footer .employee-job-detail-action-btn .iconify {
  flex-shrink: 0;
  display: block;
}

.employee-task-modal.employee-job-detail-card .modal-body .border.bg-light {
  border-color: #dee2e6 !important;
}

.employee-job-detail-card .employee-job-detail-row.border-bottom {
  border-color: #e9ecef !important;
}

/* Sub Jobs table: same responsive / compact / tooltip pattern as Jobs */
.employee-panel .employee-subjobs-table-responsive {
  -webkit-overflow-scrolling: touch;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(43, 103, 119, 0.08);
}

.employee-panel .table.employee-subjobs-table {
  font-size: 0.9375rem;
  table-layout: fixed;
  width: 100%;
  min-width: 980px;
  margin-bottom: 0;
}

/* Reserve horizontal space so action icons stay on one row */
.employee-panel .table.employee-subjobs-table th:nth-child(1),
.employee-panel .table.employee-subjobs-table td:nth-child(1) {
  width: 18%;
}

.employee-panel .table.employee-subjobs-table th:nth-child(2) {
  width: 28%;
}

.employee-panel .table.employee-subjobs-table td:nth-child(2) {
  width: 28%;
  overflow: hidden;
}

.employee-panel .table.employee-subjobs-table th:nth-child(3),
.employee-panel .table.employee-subjobs-table td:nth-child(3),
.employee-panel .table.employee-subjobs-table th:nth-child(4),
.employee-panel .table.employee-subjobs-table td:nth-child(4),
.employee-panel .table.employee-subjobs-table th:nth-child(5),
.employee-panel .table.employee-subjobs-table td:nth-child(5),
.employee-panel .table.employee-subjobs-table th:nth-child(6),
.employee-panel .table.employee-subjobs-table td:nth-child(6) {
  width: 9%;
}

.employee-panel .table.employee-subjobs-table th:last-child,
.employee-panel .table.employee-subjobs-table td:last-child {
  width: 12.75rem;
  min-width: 12.75rem;
  max-width: 12.75rem;
  box-sizing: border-box;
}

/* A bit more air before the trailing columns */
.employee-panel .table.employee-subjobs-table thead th:nth-child(n + 3),
.employee-panel .table.employee-subjobs-table tbody td:nth-child(n + 3) {
  padding-inline: 0.45rem 0.5rem;
}

.employee-panel .table.employee-subjobs-table thead th {
  font-size: 0.8125rem;
  font-weight: 600;
  padding: 0.42rem 0.36rem;
  vertical-align: middle;
}

.employee-panel .table.employee-subjobs-table tbody td {
  padding: 0.38rem 0.36rem;
  vertical-align: middle;
}

.employee-panel .table.employee-subjobs-table .badge {
  font-size: 0.78rem;
  padding: 0.35em 0.55em;
}

.employee-panel .table.employee-subjobs-table .jobs-clip-wrap {
  position: relative;
  text-align: left;
}

.employee-panel .table.employee-subjobs-table .jobs-clip-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.employee-panel .table.employee-subjobs-table .subjobs-id-cell .jobs-clip-wrap {
  max-width: 100%;
  margin-inline: auto;
}

.employee-panel .table.employee-subjobs-table .subjobs-name-cell .jobs-clip-wrap {
  max-width: 100%;
}

.employee-panel .table.employee-subjobs-table .jobs-tooltip-bubble {
  display: none;
  position: absolute;
  z-index: 1080;
  left: 50%;
  transform: translateX(-50%);
  top: calc(100% + 6px);
  min-width: min(100%, 12rem);
  max-width: min(420px, 85vw);
  max-height: 220px;
  overflow-y: auto;
  padding: 0.55rem 0.7rem;
  background: #1a3a42;
  color: #f8fafb;
  font-size: 0.875rem;
  line-height: 1.45;
  border-radius: 8px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.22);
  white-space: pre-wrap;
  word-break: break-word;
  text-align: left;
  pointer-events: auto;
}

.employee-panel .table.employee-subjobs-table .jobs-clip-wrap:hover .jobs-tooltip-bubble {
  display: block;
}

.employee-panel .table.employee-subjobs-table .jobs-tooltip-bubble::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 100%;
  height: 8px;
}

.employee-panel .table.employee-subjobs-table .jobs-tooltip-bubble::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -7px;
  border: 7px solid transparent;
  border-bottom-color: #1a3a42;
}

@media (hover: none) {
  .employee-panel .table.employee-subjobs-table .jobs-tooltip-bubble {
    display: none !important;
  }
}

.employee-panel .table.employee-subjobs-table .subjobs-actions-cell {
  white-space: nowrap;
  vertical-align: middle;
}

.employee-panel .table.employee-subjobs-table .subjobs-actions-toolbar {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
}

.employee-panel .table.employee-subjobs-table .subjobs-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 1.72rem;
  height: 1.72rem;
  padding: 0;
  margin: 0;
  overflow: visible;
  border: 1px solid #d0d9e3;
  border-radius: 0.3rem;
  background: #ffffff;
  color: #2b6777;
  transition: all 0.15s ease;
}

.employee-panel .table.employee-subjobs-table .subjobs-action-btn svg {
  flex-shrink: 0;
}

.employee-panel .table.employee-subjobs-table .subjobs-action-btn:hover {
  background: #e9f3f5;
  border-color: #52ab98;
  color: #1f5562;
}

.employee-panel .table.employee-subjobs-table .subjobs-action-btn--success {
  color: #027a48;
}

.employee-panel .table.employee-subjobs-table .subjobs-action-btn--success:hover {
  background: #ecfdf3;
  border-color: #6ce9a6;
  color: #027a48;
}

.employee-panel .table.employee-subjobs-table .subjobs-action-btn--muted {
  color: #475467;
}

.employee-panel .table.employee-subjobs-table .subjobs-action-btn--muted:hover {
  background: #f2f4f7;
  border-color: #98a2b3;
  color: #1d2939;
}

.employee-panel .table.employee-subjobs-table .subjobs-action-btn--danger {
  color: #b42318;
}

.employee-panel .table.employee-subjobs-table .subjobs-action-btn--danger:hover {
  background: #fef3f2;
  border-color: #fda29b;
  color: #b42318;
}

.employee-panel .table.employee-subjobs-table .subjobs-action-btn--warning {
  color: #b54708;
}

.employee-panel .table.employee-subjobs-table .subjobs-action-btn--warning:hover {
  background: #fffaeb;
  border-color: #fec84b;
  color: #b54708;
}

/* Logged hours tables: responsive / compact / tooltips (job logs + subtask logs) */
.employee-panel .employee-logged-hours-table-responsive {
  -webkit-overflow-scrolling: touch;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(43, 103, 119, 0.08);
}

.employee-panel .table.employee-logged-hours-table {
  font-size: 0.9375rem;
  min-width: 800px;
  margin-bottom: 0;
  table-layout: fixed;
  width: 100%;
}

.employee-panel .table.employee-logged-hours-table.employee-logged-hours-subtask-table {
  min-width: 920px;
  font-size: 1rem;
}

/* Daniyal — subtask log table: cap SubJob name column so date/time/status/actions stay readable */
.employee-panel
  .table.employee-logged-hours-table.employee-logged-hours-subtask-table
  th:nth-child(1),
.employee-panel
  .table.employee-logged-hours-table.employee-logged-hours-subtask-table
  td:nth-child(1) {
  width: 42%;
  vertical-align: middle;
}

.employee-panel
  .table.employee-logged-hours-table.employee-logged-hours-subtask-table
  td:nth-child(1) {
  overflow: hidden;
}

.employee-panel
  .table.employee-logged-hours-table.employee-logged-hours-subtask-table
  .loghours-name-cell
  .jobs-clip-wrap {
  max-width: 100%;
}

.employee-panel
  .table.employee-logged-hours-table.employee-logged-hours-subtask-table
  .loghours-actions-header,
.employee-panel
  .table.employee-logged-hours-table.employee-logged-hours-subtask-table
  .loghours-actions-cell {
  width: 5.5rem;
  max-width: 5.5rem;
}

.employee-panel
  .table.employee-logged-hours-table.employee-logged-hours-subtask-table
  .loghours-actions-toolbar {
  flex-wrap: nowrap;
  gap: 0.2rem;
}

.employee-panel .table.employee-logged-hours-table thead th {
  font-size: 0.8125rem;
  font-weight: 600;
  padding: 0.42rem 0.32rem;
  vertical-align: middle;
}

.employee-panel
  .table.employee-logged-hours-table.employee-logged-hours-subtask-table
  thead
  th {
  font-size: 0.875rem;
}

.employee-panel .table.employee-logged-hours-table tbody td {
  padding: 0.38rem 0.32rem;
  vertical-align: middle;
}

.employee-panel .table.employee-logged-hours-table .badge {
  font-size: 0.78rem;
  padding: 0.35em 0.55em;
}

.employee-panel .table.employee-logged-hours-table .jobs-clip-wrap {
  position: relative;
  text-align: left;
}

.employee-panel .table.employee-logged-hours-table .jobs-clip-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.employee-panel .table.employee-logged-hours-table .loghours-client-cell .jobs-clip-wrap {
  max-width: min(9.6rem, 20.8vw);
}

.employee-panel .table.employee-logged-hours-table .loghours-id-header,
.employee-panel .table.employee-logged-hours-table .loghours-id-cell {
  min-width: 12rem;
}

.employee-panel .table.employee-logged-hours-table .loghours-col-date {
  width: 6.35rem;
  font-variant-numeric: tabular-nums;
}

.employee-panel .table.employee-logged-hours-table .loghours-col-duration {
  width: 6.15rem;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
}

.employee-panel .table.employee-logged-hours-table .loghours-col-status {
  width: 6.65rem;
}

/* Breathing room between Date, App. time, Status, and Actions */
.employee-panel .table.employee-logged-hours-table thead th.loghours-col-date,
.employee-panel .table.employee-logged-hours-table tbody td.loghours-col-date,
.employee-panel .table.employee-logged-hours-table thead th.loghours-col-duration,
.employee-panel .table.employee-logged-hours-table tbody td.loghours-col-duration,
.employee-panel .table.employee-logged-hours-table thead th.loghours-col-status,
.employee-panel .table.employee-logged-hours-table tbody td.loghours-col-status,
.employee-panel .table.employee-logged-hours-table thead th.loghours-actions-header,
.employee-panel .table.employee-logged-hours-table tbody td.loghours-actions-cell {
  padding-inline: 0.52rem 0.58rem;
}

.employee-panel .table.employee-logged-hours-table .loghours-id-cell .jobs-clip-wrap {
  max-width: min(8rem, 22vw);
  margin-inline: 0;
}

.employee-panel .table.employee-logged-hours-table .loghours-id-cell {
  white-space: nowrap;
}

.employee-panel .table.employee-logged-hours-table .loghours-id-value {
  display: inline-block;
  white-space: nowrap;
}

.employee-panel .table.employee-logged-hours-table .loghours-name-cell .jobs-clip-wrap {
  max-width: min(14rem, 32vw);
}

.employee-panel .table.employee-logged-hours-table .loghours-note-cell .jobs-clip-wrap {
  max-width: min(7rem, 14vw);
}

.employee-panel .table.employee-logged-hours-table .jobs-tooltip-bubble {
  display: none;
  position: absolute;
  z-index: 1080;
  left: 50%;
  transform: translateX(-50%);
  top: calc(100% + 6px);
  min-width: min(100%, 12rem);
  max-width: min(420px, 85vw);
  max-height: 220px;
  overflow-y: auto;
  padding: 0.55rem 0.7rem;
  background: #1a3a42;
  color: #f8fafb;
  font-size: 0.875rem;
  line-height: 1.45;
  border-radius: 8px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.22);
  white-space: pre-wrap;
  word-break: break-word;
  text-align: left;
  pointer-events: auto;
}

.employee-panel .table.employee-logged-hours-table .jobs-clip-wrap:hover .jobs-tooltip-bubble {
  display: block;
}

.employee-panel .table.employee-logged-hours-table .jobs-tooltip-bubble::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 100%;
  height: 8px;
}

.employee-panel .table.employee-logged-hours-table .jobs-tooltip-bubble::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -7px;
  border: 7px solid transparent;
  border-bottom-color: #1a3a42;
}

@media (hover: none) {
  .employee-panel .table.employee-logged-hours-table .jobs-tooltip-bubble {
    display: none !important;
  }
}

.employee-panel .table.employee-logged-hours-table .loghours-actions-header,
.employee-panel .table.employee-logged-hours-table .loghours-actions-cell {
  width: 5.05rem;
  max-width: 5.05rem;
  box-sizing: border-box;
}

.employee-panel .table.employee-logged-hours-table .loghours-actions-toolbar {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0;
}

.employee-panel .table.employee-logged-hours-table .loghours-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 1.5rem;
  height: 1.5rem;
  padding: 0;
  margin: 0;
  overflow: visible;
  border: 1px solid #d0d9e3;
  border-radius: 0.26rem;
  background: #ffffff;
  color: #2b6777;
  transition: all 0.15s ease;
}

.employee-panel .table.employee-logged-hours-table .loghours-action-btn svg {
  width: 1.5rem;
  height: 1.5rem;
  flex-shrink: 0;
}

.employee-panel .table.employee-logged-hours-table .loghours-action-btn:hover {
  background: #e9f3f5;
  border-color: #52ab98;
  color: #1f5562;
}

.employee-panel .table.employee-logged-hours-table .loghours-action-btn--danger {
  color: #b42318;
}

.employee-panel .table.employee-logged-hours-table .loghours-action-btn--danger:hover {
  background: #fef3f2;
  border-color: #fda29b;
  color: #b42318;
}

.employee-panel .table.employee-logged-hours-table .loghours-actions-cell .badge {
  white-space: nowrap;
}

.employee-panel .employee-log-detail-card {
  border-radius: 0.9rem;
  overflow: hidden;
}

.employee-panel .employee-log-detail-header {
  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
}

.employee-panel .employee-log-detail-item {
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  padding: 0.75rem 0.85rem;
  background: #f8fafc;
  min-height: 100%;
}

.employee-panel .employee-log-detail-label {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #64748b;
  margin-bottom: 0.2rem;
}

.employee-panel .employee-log-detail-value {
  font-size: 0.92rem;
  font-weight: 500;
  color: #0f172a;
  word-break: break-word;
}

.employee-panel .employee-log-detail-notes {
  white-space: pre-wrap;
}

.employee-panel .subjob-view-commit-repo:last-child {
  margin-bottom: 0 !important;
}

.employee-panel .subjob-view-commit-hash {
  font-size: 0.75rem;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 0.12rem 0.4rem;
  color: #334155;
}

/* DatePicker custom styling */
.react-datepicker-wrapper {
  width: 100%;
}

.react-datepicker__input-container {
  width: 100%;
}

.react-datepicker-popper {
  z-index: 9999 !important;
}

.react-datepicker {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
  border: 1px solid #c8d8e4 !important;
  border-radius: 8px !important;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1) !important;
}

.react-datepicker__header {
  background-color: #2b6777 !important;
  border-bottom: none !important;
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
  padding-top: 8px !important;
}

.react-datepicker__current-month, 
.react-datepicker__day-name {
  color: #ffffff !important;
}

.react-datepicker__navigation {
  top: 10px !important;
}

.react-datepicker__day--selected, 
.react-datepicker__day--in-selecting-range, 
.react-datepicker__day--in-range {
  background-color: #52ab98 !important;
  border-radius: 50% !important;
}

.react-datepicker__day:hover {
  background-color: #c8d8e4 !important;
  border-radius: 50% !important;
}

.status-dropdown {
  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);
  color: #fff;
  border: 1px solid #1c3932;
  border-radius: 8px;
  padding: 6px 32px 6px 12px;
  font-size: 1rem;
  font-weight: 500;
  outline: none;
  appearance: none;
  min-width: 100px;
  margin-left: 8px;
  box-shadow: 0 2px 6px rgba(43, 103, 119, 0.08);
  transition: border 0.2s, box-shadow 0.2s;
  cursor: pointer;
  /* Custom arrow */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px 16px;
}

.status-dropdown:focus {
  border: 2px solid #52ab98;
  box-shadow: 0 0 0 2px #52ab9855;
}

.status-dropdown option {
  color: #2b6777;
  background: #fff;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;AACA,SAAS;AACT,UAAU;EACR,4DAA4D;AAC9D;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,6DAA6D;EAC7D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,KAAK,uCAAuC,EAAE;EAC9C,MAAM,6CAA6C,EAAE;EACrD,MAAM,6CAA6C,EAAE;EACrD,MAAM,+CAA+C,EAAE;EACvD,OAAO,uCAAuC,EAAE;AAClD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,oDAAoD;EACpD,cAAc;EACd,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,KAAK,QAAQ,EAAE;EACf,OAAO,YAAY,EAAE;AACvB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gDAAgD;EAChD,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,WAAW;EACX;;;;GAIC;EACD,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,0BAA0B;AAC1B;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA,0GAA0G;AAC1G;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,IAAI,mBAAmB,CAAC;AACxB,MAAM,kCAAkC,CAAC;AACzC;EACE,iBAAiB;AACnB;AACA,4BAA4B,YAAY,EAAE,aAAa,EAAE,yBAAyB,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAEvH;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;GACG;;AAEH;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,gBAAgB;;AAEhB,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,4DAA4D;EAC5D,aAAa;EACb,4DAA4D;EAC5D,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,oBAAoB;EACpB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;EAC5C,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA,uDAAuD;AACvD;EACE,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;EAC/C,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,4DAA4D;AAC9D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,6EAA6E;EAC7E,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe,0BAA0B,EAAE;EAC3C,gBAAgB,sBAAsB,EAAE;EACxC,+BAA+B,eAAe,EAAE;AAClD;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wDAAwD;EACxD,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,wDAAwD;EACxD,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,sGAAsG;AACtG;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,0EAA0E;EAC1E,WAAW;EACX,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,+CAA+C;EAC/C,eAAe;EACf;;;;wBAIsB;EACtB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;EAChD,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,0EAA0E;AAC5E;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,wBAAwB;AACxB;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,+DAA+D;AAC/D;;;EAGE,6CAA6C;EAC7C,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA,wEAAwE;AACxE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,mBAAmB;EACnB,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,6EAA+V;AACjW;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;EAKE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;;;;EAKE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yDAAiP;EACjP,4BAA4B;EAC5B,yCAAyC;EACzC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA,mDAAmD;AACnD;EACE,mBAAmB;EACnB,gBAAgB;EAChB;;sCAEoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,0EAA0E;EAC1E,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX;;;;;GAKC;EACD,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uFAAuF;EACvF,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB;;uCAEqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA,6DAA6D;AAC7D;;;;;EAKE,yBAAyB;EACzB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,6DAA6D;EAC7D,yCAAyC;EACzC,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB;;0CAEwC;AAC1C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,oDAAoD;EACpD,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;EAC9C,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;EAC/C,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;EACxC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,gEAAgE;AAChE;EACE,oBAAoB;EACpB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB;;sCAEoC;AACtC;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf;;;;wBAIsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,mFAAmF;AACnF;;EAEE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,2CAA2C;EAC3C,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,uBAAuB;EACzB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,sEAAsE;AACtE;;;EAGE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,wBAAwB;EACxB,sBAAsB;EACtB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,WAAW;EACX,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,+FAA+F;AAC/F;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;EACzB;qDACmD;EACnD,uCAAuC;EACvC,iDAAiD;EACjD,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,0DAA0D;AAC1D;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,6DAA6D;EAC7D,wCAAwC;EACxC,oBAAoB;EACpB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,4CAA4C;EAC5C,oBAAoB;EACpB,UAAU;AACZ;;AAEA;;EAEE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,uHAAuH;AACvH;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,mEAAmE;AACnE;EACE,aAAa;AACf;;AAEA,yDAAyD;AACzD;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,uDAAuD;EACvD,gCAAgC;AAClC;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,8DAA8D;AAC9D;EACE,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,wEAAwE;AACxE;EACE,iCAAiC;EACjC,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;;EAEE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;;EAEE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,mFAAmF;AACnF;EACE,iCAAiC;EACjC,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,kGAAkG;AAClG;;;;;;EAME,UAAU;EACV,sBAAsB;AACxB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;;;EAME,aAAa;EACb,iBAAiB;AACnB;;AAEA;;;EAGE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,gEAAgE;AAChE;;;;;;;;EAQE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;EAC3B,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,MAAM;AACR;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uEAAuE;EACvE,oCAAoC;EACpC,6BAA6B;EAC7B,oDAAoD;AACtD;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,sCAAsC;EACtC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;EAGE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,8CAA8C;EAC9C,wCAAwC;EACxC,eAAe;EACf,iBAAiB;EACjB,yDAAkK;EAClK,4BAA4B;EAC5B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["body {\nmargin: 0;\npadding: 0;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n/* Enhanced Login Page Styles */\n.login-page {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: #f2f2f2;\n  background: linear-gradient(135deg, #f2f2f2 0%, #c8d8e4 100%);\n  overflow: hidden;\n  position: relative;\n}\n\n.login-page::before {\n  content: '';\n  position: absolute;\n  width: 300px;\n  height: 300px;\n  background-color: rgba(43, 103, 119, 0.1);\n  border-radius: 50%;\n  top: -150px;\n  left: -100px;\n  animation: float 15s infinite ease-in-out;\n}\n\n.login-page::after {\n  content: '';\n  position: absolute;\n  width: 250px;\n  height: 250px;\n  background-color: rgba(82, 171, 152, 0.1);\n  border-radius: 50%;\n  bottom: -100px;\n  right: -50px;\n  animation: float 20s infinite ease-in-out reverse;\n}\n\n@keyframes float {\n  0% { transform: translate(0, 0) rotate(0deg); }\n  25% { transform: translate(10px, 20px) rotate(5deg); }\n  50% { transform: translate(20px, 10px) rotate(0deg); }\n  75% { transform: translate(10px, -10px) rotate(-5deg); }\n  100% { transform: translate(0, 0) rotate(0deg); }\n}\n\n.login-container {\n  z-index: 10;\n  max-width: 450px;\n  width: 100%;\n  padding: 20px;\n}\n\n.tracker-header {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.tracker-header h1 {\n  font-size: 3rem;\n  color: #2b6777;\n  font-weight: 700;\n  letter-spacing: 4px;\n  margin-bottom: 0;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);\n  animation: fadeInDown 1s forwards;\n}\n\n.animated-underline {\n  height: 4px;\n  width: 0;\n  background: linear-gradient(90deg, #2b6777, #52ab98);\n  margin: 0 auto;\n  border-radius: 2px;\n  animation: expandWidth 1.5s forwards 0.5s;\n}\n\n@keyframes expandWidth {\n  0% { width: 0; }\n  100% { width: 180px; }\n}\n\n@keyframes fadeInDown {\n  0% { \n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  100% { \n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.login-card {\n  background-color: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 10px 30px rgba(43, 103, 119, 0.15);\n  padding: 40px;\n  text-align: center;\n  transform: translateY(20px);\n  opacity: 0;\n  animation: fadeInUp 1s forwards 0.8s;\n}\n\n@keyframes fadeInUp {\n  0% { \n    opacity: 0;\n    transform: translateY(20px);\n  }\n  100% { \n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.login-card h2 {\n  margin-bottom: 30px;\n  color: #2b6777;\n  font-size: 1.8rem;\n  font-weight: 600;\n}\n\n.login-card form {\n  display: flex;\n  flex-direction: column;\n}\n\n.input-group {\n  margin-bottom: 25px;\n  text-align: left;\n  position: relative;\n}\n\n.input-group label {\n  display: block;\n  margin-bottom: 8px;\n  color: #2b6777;\n  font-weight: 500;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.login-input {\n  width: 100%;\n  padding: 12px 15px;\n  background-color: #f2f2f2;\n  border: 2px solid transparent;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.login-input:focus {\n  outline: none;\n  border-color: #52ab98;\n  box-shadow: 0 0 0 3px rgba(82, 171, 152, 0.2);\n}\n\n.login-input::placeholder {\n  color: #a0a0a0;\n}\n\n.login-button {\n  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);\n  color: white;\n  padding: 14px;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 10px;\n  position: relative;\n  overflow: hidden;\n}\n\n.login-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(43, 103, 119, 0.2);\n}\n\n.login-button:active {\n  transform: translateY(0);\n}\n\n.login-button::after {\n  content: '';\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: -100%;\n  background: linear-gradient(90deg, \n    rgba(255, 255, 255, 0.1), \n    rgba(255, 255, 255, 0.4), \n    rgba(255, 255, 255, 0.1)\n  );\n  transition: all 0.3s ease;\n}\n\n.login-button:hover::after {\n  left: 100%;\n}\n\n.login-button.loading {\n  background: #52ab98;\n}\n\n/* Spinner animation */\n.spinner {\n  display: flex;\n  justify-content: center;\n}\n\n.spinner > div {\n  width: 10px;\n  height: 10px;\n  margin: 0 3px;\n  background-color: #ffffff;\n  border-radius: 50%;\n  animation: bounce 1.4s infinite ease-in-out both;\n}\n\n.spinner .bounce1 {\n  animation-delay: -0.32s;\n}\n\n.spinner .bounce2 {\n  animation-delay: -0.16s;\n}\n\n@keyframes bounce {\n  0%, 80%, 100% {\n    transform: scale(0);\n  }\n  40% {\n    transform: scale(1);\n  }\n}\n\n/* Original Styles Below */\n.container {\n  width: 100%;\n}\n\n.login{\n  display: flex;\n  align-items: center;\n  height: 100vh;\n}\n\n/* Original login card styles - these are now overridden by the enhanced styles above for the login page */\n.modal-body h2 {\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.modal-body form {\n  display: flex;\n  flex-direction: column;\n}\n\n.modal-body label {\n  text-align: left;\n  margin-bottom: 8px;\n  color: #555;\n}\n\n.modal-body input {\n  padding: 10px;\n  margin-bottom: 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.modal-body button {\n  background-color: #3083DC;\n  color: #fff;\n  padding: 10px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.nr{white-space: nowrap;}\n.bg-t{background: transparent !important;}\n.admin-button{ \n  margin-top: 11rem;\n}\n.admin-button .bttn button{ width: 400px; height: 150px; background-color: #EAECF0; font-size: 20px; font-weight: 500; }\n\n.header{ \n  background-color: #EAECF0; \n  border-radius: 8px; \n  padding: 7px; \n  margin-top: 11px;\n}\n.header h2{ \n  font-size: 25px; \n  padding: 6px 11px;\n}\n\n/* Message start */\n.typing-loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n}\n\n.typing-dot {\n  width: 8px;\n  height: 8px;\n  background-color: #64c782;\n  border-radius: 50%;\n  margin: 0 4px;\n  animation: bounce 1.4s infinite ease-in-out;\n}\n\n.typing-dot:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.typing-dot:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n/* .chat-container {\n} */\n\n.header {\n  background: #f5f8f5;\n  padding: 10px;\n}\n\n.body {\n  flex: 1;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n}\n\n.user-details {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.user-details span {\n  width: 60px;\n  min-width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  overflow: hidden;\n}\n\n.user-details span img {\n  max-width: 100%;\n  height: auto;\n}\n\n.user-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.user-info h5 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 500;\n}\n\n.user-info p {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.chat-box {\n  position: relative;\n  margin: 10px 0;\n  padding: 10px 20px;\n  border-radius: 10px;\n  background-color: #e0e0e0;\n  width: fit-content;\n  max-width: 80%;\n}\n\n.chat-box p {\n  margin: 0;\n  color: #f5f5f5;\n}\n\n.chat-box.sender {\n  background-color: #3083DC;\n  align-self: flex-end;\n  justify-self:flex-end ;\n}\n\n.chat-box.receiver {\n  background-color: #5d99d8;\n  align-self: flex-start;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.chat-box.sender::before {\n  content: \"\";\n  position: absolute;\n  bottom: 1px;\n  right: -15px;\n  width: 15px;\n  height: 20px;\n  z-index: 9;\n  border-radius: 0 0 0 20px;\n  background: #fff;\n}\n\n.chat-box.sender::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  right: -9px;\n  width: 18px;\n  height: 15px;\n  background: #3083DC;\n}\n\n.chat-box.receiver::before {\n  content: \"\";\n  position: absolute;\n  bottom: 1px;\n  left: -15px;\n  width: 15px;\n  height: 20px;\n  z-index: 1;\n  border-radius: 0 0 20px 0;\n  background: #fff;\n}\n\n.chat-box.receiver::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: -9px;\n  width: 18px;\n  height: 15px;\n  background: #5d99d8;\n}\n\n.sender .status {\n  text-align: right;\n}\n\n.status {\n  font-size: 10px;\n  margin-top: 5px;\n  color: #999;\n}\n\n.input-container {\n  margin-top: 16px;\n  display: flex;\n}\n\n.input-container input {\n  flex: 1;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin-right: 8px;\n}\n\n.input-container button {\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 10px 16px;\n  cursor: pointer;\n}\n\n.text-red{\n  color: red;\n}\n\nth.text-green{\n  color: rgb(64, 203, 64);\n}\n\n.search-bar{\n  width: 100%;\n}\n\n.color-blue{\n  color: blue;\n}\n\n.cursor-pointer{\n  cursor: pointer;\n}\n\n.text-truncate {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n/* Message End */\n\n/* New Admin Page Styles */\n.admin-page {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f2f2f2 0%, #c8d8e4 70%);\n  padding: 30px;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  overflow-x: hidden;\n}\n\n.client-group-hours-table-wrap {\n  max-height: 50vh;\n  overflow: auto;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  -webkit-overflow-scrolling: touch;\n}\n\n.client-group-hours-table {\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.client-group-hours-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 3;\n  background: #d7efe0;\n  box-shadow: 0 1px 0 0 #dee2e6;\n  white-space: nowrap;\n}\n\n.admin-container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.admin-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  background-color: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 6px 15px rgba(43, 103, 119, 0.1);\n  margin-bottom: 30px;\n  animation: slideDown 0.8s ease-out forwards;\n}\n\n@keyframes slideDown {\n  from {\n    transform: translateY(-50px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.admin-header h1 {\n  color: #2b6777;\n  font-size: 32px;\n  font-weight: 700;\n  margin: 0;\n}\n\n.logout-button {\n  background-color: white;\n  color: #2b6777;\n  border: 2px solid #2b6777;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.logout-button:hover {\n  background-color: #2b6777;\n  color: white;\n}\n\n.logout-icon {\n  display: flex;\n  align-items: center;\n}\n\n.admin-dashboard {\n  background-color: white;\n  border-radius: 12px;\n  box-shadow: 0 6px 15px rgba(43, 103, 119, 0.1);\n  padding: 30px;\n  animation: fadeIn 1.2s ease-out forwards;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.dashboard-header {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.dashboard-header h2 {\n  color: #2b6777;\n  font-size: 24px;\n  margin-bottom: 10px;\n}\n\n.dashboard-header p {\n  color: #666;\n  font-size: 16px;\n}\n\n.admin-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.admin-card {\n  background-color: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  border: 2px solid transparent;\n}\n\n.admin-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 5px;\n  background: linear-gradient(90deg, #2b6777, #52ab98);\n  transform: scaleX(0);\n  transform-origin: left;\n  transition: transform 0.5s ease;\n}\n\n.admin-card:hover {\n  transform: translateY(-5px);\n  border-color: rgba(82, 171, 152, 0.2);\n}\n\n.admin-card:hover::before {\n  transform: scaleX(1);\n}\n\n.card-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 60px;\n  border-radius: 12px;\n  margin-bottom: 16px;\n  color: white;\n}\n\n.user-icon {\n  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);\n}\n\n.delete-icon {\n  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);\n}\n\n.report-icon {\n  background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);\n}\n\n.ai-icon {\n  background: linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%);\n}\n\n.tracking-icon {\n  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);\n}\n\n.worklog-icon {\n  background: linear-gradient(135deg, #d97706 0%, #b45309 100%);\n}\n\n.admin-worklog-filters {\n  padding: 0;\n}\n\n.admin-worklog-date-row {\n  display: flex;\n  gap: 1rem;\n}\n\n.admin-worklog-date-field {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.admin-worklog-request-btn {\n  width: 100%;\n}\n\n.admin-worklog-back-btn {\n  color: #2b6777;\n  text-decoration: none;\n  line-height: 1;\n}\n\n.admin-worklog-back-btn:hover {\n  color: #1f5562;\n}\n\n.admin-worklog-results {\n  max-height: min(65vh, 560px);\n  overflow: auto;\n}\n\n.admin-worklog-json {\n  font-size: 0.8125rem;\n  background: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 0.375rem;\n  padding: 0.75rem;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.admin-worklog-report {\n  --worklog-accent: #d97706;\n  --worklog-accent-soft: #fff7ed;\n}\n\n.admin-worklog-stat-card {\n  background: #f8fafb;\n  border: 1px solid #e3e9ef;\n  border-radius: 10px;\n  padding: 0.85rem 1rem;\n}\n\n.admin-worklog-stat-card--accent {\n  background: var(--worklog-accent-soft);\n  border-color: #fed7aa;\n}\n\n.admin-worklog-stat-label {\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #64748b;\n  margin-bottom: 0.35rem;\n}\n\n.admin-worklog-stat-value {\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: #1e293b;\n  line-height: 1.35;\n}\n\n.admin-worklog-stat-value--sm {\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.admin-worklog-section-title {\n  font-size: 0.8rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #2b6777;\n  margin-bottom: 0.65rem;\n}\n\n.admin-worklog-section-title--warning {\n  color: #b45309;\n}\n\n.admin-worklog-repo-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.admin-worklog-repo-badge {\n  background: #e9f3f5;\n  color: #000;\n  border: 1px solid #b8d4da;\n  font-weight: 500;\n  font-size: 0.78rem;\n  padding: 0.4em 0.75em;\n}\n\n.admin-worklog-table-wrap {\n  border: 1px solid #e3e9ef;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.admin-worklog-table thead th {\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  white-space: nowrap;\n}\n\n.admin-worklog-desc-cell {\n  min-width: 10rem;\n  max-width: 16rem;\n}\n\n.admin-worklog-commits-cell {\n  min-width: 8rem;\n  max-width: 14rem;\n}\n\n.admin-worklog-commit-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n}\n\n.admin-worklog-commit-tag {\n  font-size: 0.68rem;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  padding: 0.1rem 0.35rem;\n  color: #334155;\n}\n\n.admin-worklog-verify-link {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.admin-worklog-verify-link:hover {\n  text-decoration: underline;\n}\n\n.admin-worklog-blockers-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.admin-worklog-blockers-list li {\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n  border-left: 3px solid var(--worklog-accent);\n  border-radius: 6px;\n  padding: 0.55rem 0.75rem;\n  font-size: 0.875rem;\n  color: #7c2d12;\n}\n\n.card-content h3 {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: #2b6777;\n}\n\n.card-content p {\n  color: #666;\n  font-size: 14px;\n  margin: 0;\n}\n\n/* Modal Styling Updates */\n.modal-content {\n  border-radius: 12px;\n  border: none;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.modal-header {\n  background-color: #2b6777;\n  color: white;\n  border-bottom: none;\n}\n\n.modal-header .modal-title {\n  font-weight: 600;\n}\n\n.modal-header .btn-close {\n  color: white;\n  opacity: 0.8;\n}\n\n.modal-footer {\n  border-top: none;\n  padding-top: 0;\n}\n\n.btn-primary {\n  background-color: #2b6777;\n  border-color: #2b6777;\n}\n\n.btn-primary:hover {\n  background-color: #52ab98;\n  border-color: #52ab98;\n}\n\n.btn-secondary {\n  background-color: #c8d8e4;\n  border-color: #c8d8e4;\n  color: #2b6777;\n}\n\n.btn-secondary:hover {\n  background-color: #a1c6de;\n  border-color: #a1c6de;\n  color: #2b6777;\n}\n\n.form-control:focus {\n  border-color: #52ab98;\n  box-shadow: 0 0 0 0.25rem rgba(82, 171, 152, 0.25);\n}\n\n/* Enhanced Modal Styles for Add User and Delete User */\n.user-modal .modal-content {\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 15px 30px rgba(43, 103, 119, 0.2);\n  border: none;\n}\n\n.user-modal .modal-header {\n  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);\n  color: #ffffff;\n  padding: 20px 24px;\n  border-bottom: none;\n}\n\n.user-modal .modal-header .modal-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.user-modal .modal-header .btn-close {\n  background-color: rgba(255, 255, 255, 0.5);\n  border-radius: 50%;\n  padding: 6px;\n  transition: all 0.3s ease;\n}\n\n.user-modal .modal-header .btn-close:hover {\n  background-color: rgba(255, 255, 255, 0.8);\n  transform: scale(1.1);\n}\n\n.user-modal .modal-body {\n  padding: 30px;\n  background-color: #ffffff;\n}\n\n.user-modal .modal-body form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.user-modal .form-group {\n  margin-bottom: 20px;\n}\n\n.user-modal label {\n  display: block;\n  color: #2b6777;\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n\n.user-modal input[type=\"text\"],\n.user-modal input[type=\"password\"] {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #c8d8e4;\n  border-radius: 8px;\n  background-color: #f2f2f2;\n  color: #333;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.user-modal input[type=\"text\"]:focus,\n.user-modal input[type=\"password\"]:focus {\n  border-color: #52ab98;\n  box-shadow: 0 0 0 3px rgba(82, 171, 152, 0.2);\n  outline: none;\n}\n\n.user-modal .checkbox-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.user-modal .checkbox-container input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: #52ab98;\n}\n\n.user-modal .form-button {\n  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 24px;\n  font-weight: 600;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 10px;\n}\n\n.user-modal .form-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(43, 103, 119, 0.2);\n}\n\n.user-modal .form-button:active {\n  transform: translateY(0);\n}\n\n.user-modal .cancel-button {\n  background-color: #f2f2f2;\n  color: #2b6777;\n  border: 2px solid #c8d8e4;\n  border-radius: 8px;\n  padding: 10px 20px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.user-modal .cancel-button:hover {\n  background-color: #c8d8e4;\n}\n\n.user-modal .modal-footer {\n  border-top: none;\n  padding: 16px 24px 24px;\n  background-color: #ffffff;\n}\n\n/* Specific styles for Delete User Modal */\n.delete-user-modal .modal-header {\n  background: linear-gradient(135deg, #2b6777 0%, #e74c3c 80%);\n}\n\n.delete-user-modal .form-button {\n  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);\n}\n\n.delete-user-modal .warning-text {\n  color: #e74c3c;\n  font-weight: 500;\n  margin-bottom: 20px;\n}\n\n/* Animation for modals */\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: scale(0.9);\n}\n\n.modal.show .modal-dialog {\n  transform: scale(1);\n}\n\n/* Report Modal Styles */\n.report-section {\n  margin-bottom: 1.25rem;\n  padding: 1rem 1.25rem;\n  background: #ffffff;\n  border-radius: 10px;\n  border: 1px solid #e9ecef;\n}\n\n.section-title {\n  display: flex;\n  align-items: center;\n  margin-bottom: 1.25rem;\n  color: #495057;\n  font-weight: 600;\n  font-size: 1.05rem;\n  border-bottom: 1px solid #e9ecef;\n  padding-bottom: 0.5rem;\n}\n\n.button-group {\n  display: flex;\n  gap: 0.75rem;\n  margin-top: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.button-group .report-button {\n  flex: 1;\n  min-width: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.6rem 1rem;\n  background: #ffffff !important;\n  color: black !important;\n  border: 1px solid #0d6efd !important;\n  border-radius: 8px;\n  font-weight: 500;\n  transition: all 0.2s ease-in-out;\n  text-decoration: none;\n}\n\n.button-group .report-button:hover:not(.disabled) {\n  background: #0d6efd !important;\n  color: #ffffff !important;\n  box-shadow: 0 2px 8px rgba(13, 110, 253, 0.25);\n}\n\n.button-group .report-button.disabled {\n  background: #f1f3f5 !important;\n  color: #868e96;\n  border-color: #dee2e6;\n  cursor: not-allowed;\n}\n\n.option-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1rem;\n  margin-top: 0.75rem;\n}\n\n.option-card {\n  background: #ffffff !important;\n  color: #212529 !important;\n  border: 1px solid #e9ecef;\n  border-radius: 10px;\n  padding: 1rem 1.25rem;\n  text-align: left;\n  transition: box-shadow 0.2s ease, transform 0.1s ease, border-color 0.2s ease;\n  cursor: pointer;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.875rem;\n  min-height: 96px;\n}\n\n.option-card:hover {\n  border-color: #cfd8e3;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 18px rgba(33, 37, 41, 0.08);\n}\n\n.option-icon {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  background: #eef4ff;\n  border: 1px solid #dee6ff;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #0d6efd;\n}\n\n.option-content h6 {\n  margin: 0 0 0.35rem 0;\n  font-weight: 600;\n  color: #212529;\n  font-size: 1rem;\n}\n\n.option-content p {\n  margin: 0;\n  color: #6c757d;\n  font-size: 0.9rem;\n  line-height: 1.4;\n}\n\n@media (max-width: 768px) {\n  .option-grid { grid-template-columns: 1fr; }\n  .button-group { flex-direction: column; }\n  .button-group .report-button { min-width: auto; }\n}\n.report-modal .modal-content {\n  border-radius: 16px;\n  border: none;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.report-modal .modal-header {\n  background: linear-gradient(135deg, #2b6777, #52ab98);\n  color: white;\n  border-bottom: none;\n  padding: 20px 25px;\n}\n\n.report-modal .modal-title {\n  font-weight: 600;\n  font-size: 1.2rem;\n}\n\n.report-modal .modal-body {\n  padding: 25px;\n  background-color: #ffffff;\n}\n\n.report-modal .form-group {\n  margin-bottom: 20px;\n}\n\n.report-modal .form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #2b6777;\n}\n\n.report-modal .dropdown button {\n  background-color: #f2f2f2;\n  border: 1px solid #c8d8e4;\n  border-radius: 8px;\n  padding: 10px 15px;\n  width: 100%;\n  text-align: left;\n  color: #333;\n  transition: all 0.3s ease;\n}\n\n.report-modal .dropdown button:hover,\n.report-modal .dropdown button:focus {\n  background-color: #e8f0f5;\n  border-color: #52ab98;\n}\n\n.report-modal .dropdown-menu {\n  width: 100%;\n  border-radius: 8px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e0e0e0;\n}\n\n.report-modal .dropdown-item {\n  padding: 10px 15px;\n  transition: background-color 0.2s;\n}\n\n.report-modal .dropdown-item:hover {\n  background-color: #e8f0f5;\n  color: #2b6777;\n}\n\n.report-modal .form-control {\n  border-radius: 8px;\n  padding: 12px 15px;\n  border: 1px solid #c8d8e4;\n  transition: all 0.3s ease;\n}\n\n.report-modal .form-control:focus {\n  border-color: #52ab98;\n  box-shadow: 0 0 0 3px rgba(82, 171, 152, 0.25);\n}\n\n.report-modal .option-container {\n  display: flex;\n  gap: 15px;\n  margin-top: 15px;\n  flex-wrap: wrap;\n}\n\n.report-modal .option-button {\n  background: linear-gradient(to bottom, #f2f2f2, #e6e6e6);\n  color: #2b6777;\n  border: 1px solid #c8d8e4;\n  border-radius: 8px;\n  padding: 10px 20px;\n  flex: 1;\n  min-width: 120px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.report-modal .option-button:hover {\n  background: linear-gradient(to bottom, #e6e6e6, #d9d9d9);\n  border-color: #2b6777;\n  transform: translateY(-2px);\n}\n\n.report-modal .report-button {\n  background: linear-gradient(135deg, #2b6777, #52ab98);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 20px;\n  font-weight: 500;\n  width: 100%;\n  margin-top: 10px;\n  transition: all 0.3s ease;\n}\n\n.report-modal .report-button:hover:not(.disabled) {\n  background: linear-gradient(135deg, #245a67, #479e8c);\n  box-shadow: 0 4px 12px rgba(43, 103, 119, 0.3);\n  transform: translateY(-2px);\n}\n\n.report-modal .report-button.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background: #a0a0a0;\n}\n\n.report-modal .form-button {\n  background-color: #52ab98;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 20px;\n  font-weight: 500;\n  width: 100%;\n  transition: all 0.3s ease;\n}\n\n.report-modal .form-button:hover {\n  background-color: #479e8c;\n  box-shadow: 0 4px 12px rgba(82, 171, 152, 0.3);\n}\n\n.report-modal .cancel-button {\n  background-color: transparent;\n  color: #2b6777;\n  border: 1px solid #c8d8e4;\n  border-radius: 8px;\n  padding: 10px 20px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.report-modal .cancel-button:hover {\n  background-color: #f2f2f2;\n  border-color: #2b6777;\n}\n\n.report-modal .modal-footer {\n  border-top: 1px solid #f2f2f2;\n  padding: 15px 25px;\n}\n\n/* AI Report entry hub (Admin) — not `.report-modal` so header/tiles are not forced to report styles */\n.ai-report-hub-modal .modal-content {\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 16px 48px rgba(15, 45, 55, 0.18);\n}\n\n.ai-report-hub-modal-header {\n  background: linear-gradient(135deg, #2b6777 0%, #3a7a8c 45%, #52ab98 100%);\n  color: #fff;\n  border-bottom: none;\n  padding: 1.35rem 1.5rem 1.25rem;\n}\n\n.ai-report-hub-modal .modal-title {\n  color: #fff;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n\n.ai-report-hub-modal-subtitle {\n  color: rgba(255, 255, 255, 0.88);\n  line-height: 1.45;\n  max-width: 36rem;\n}\n\n.ai-report-hub-modal-body {\n  padding: 1.75rem 1.5rem 2rem;\n  background: linear-gradient(180deg, #f5f9f8 0%, #eef4f3 100%);\n}\n\n.ai-report-hub-tile {\n  position: relative;\n  height: 100%;\n  min-height: 176px;\n  padding: 1.5rem 1.35rem 1.4rem;\n  border-radius: 16px;\n  border: 1px solid #d5e2e6;\n  background: #fff;\n  box-shadow: 0 4px 14px rgba(43, 103, 119, 0.06);\n  cursor: pointer;\n  transition:\n    border-color 0.2s ease,\n    box-shadow 0.22s ease,\n    transform 0.18s ease,\n    background 0.2s ease;\n  outline: none;\n}\n\n.ai-report-hub-tile:hover {\n  border-color: #52ab98;\n  box-shadow: 0 14px 36px rgba(43, 103, 119, 0.14);\n  transform: translateY(-3px);\n  background: #fff;\n}\n\n.ai-report-hub-tile:focus-visible {\n  outline: 3px solid rgba(82, 171, 152, 0.55);\n  outline-offset: 3px;\n}\n\n.ai-report-hub-tile:active {\n  transform: translateY(-1px);\n}\n\n.ai-report-hub-tile--accent {\n  border-color: #c5d8de;\n  background: linear-gradient(165deg, #ffffff 0%, #f0faf7 55%, #e8f5f1 100%);\n}\n\n.ai-report-hub-tile--accent:hover {\n  background: #fff;\n}\n\n.ai-report-hub-tile-icon {\n  width: 52px;\n  height: 52px;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1rem;\n  background: linear-gradient(145deg, #2b6777, #52ab98);\n  color: #fff;\n  font-size: 1.2rem;\n  box-shadow: 0 6px 16px rgba(43, 103, 119, 0.25);\n}\n\n.ai-report-hub-tile--accent .ai-report-hub-tile-icon {\n  background: linear-gradient(145deg, #1f5566, #449e8a);\n}\n\n.ai-report-hub-tile-title {\n  font-size: 1.15rem;\n  font-weight: 650;\n  color: #1a3d47;\n  margin: 0 0 0.5rem;\n  letter-spacing: 0.01em;\n}\n\n.ai-report-hub-tile-desc {\n  margin: 0;\n  font-size: 0.875rem;\n  line-height: 1.55;\n  color: #4a5f66;\n}\n\n/* AI Modal Styles */\n.ai-modal .modal-content {\n  border-radius: 16px;\n  border: none;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.ai-modal .modal-header {\n  background: linear-gradient(135deg, #2b6777, #52ab98);\n  color: white;\n  border-bottom: none;\n  padding: 20px 25px;\n}\n\n.ai-modal .modal-title {\n  font-weight: 600;\n  font-size: 1.2rem;\n}\n\n.ai-modal .modal-body {\n  padding: 20px;\n  background-color: #ffffff;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.ai-modal .dropdown-toggle {\n  background-color: #f2f2f2;\n  border: 1px solid #c8d8e4;\n  border-radius: 8px;\n  padding: 10px 15px;\n  text-align: left;\n  color: #333;\n  transition: all 0.3s ease;\n  margin-bottom: 15px;\n  width: 100%;\n  max-width: 300px;\n}\n\n.ai-modal .dropdown-toggle:hover,\n.ai-modal .dropdown-toggle:focus {\n  background-color: #e8f0f5;\n  border-color: #52ab98;\n}\n\n.ai-modal .form-group {\n  margin-bottom: 20px;\n}\n\n.ai-modal .form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #2b6777;\n}\n\n.ai-modal .form-control {\n  border-radius: 8px;\n  padding: 12px 15px;\n  border: 1px solid #c8d8e4;\n  transition: all 0.3s ease;\n}\n\n.ai-modal .form-control:focus {\n  border-color: #52ab98;\n  box-shadow: 0 0 0 3px rgba(82, 171, 152, 0.25);\n  outline: none;\n}\n\n.ai-modal .chat-container {\n  background-color: #f7f9fc;\n  border-radius: 12px;\n  padding: 15px;\n  margin: 20px 0;\n  max-height: 350px;\n  overflow-y: auto;\n}\n\n.ai-modal .message {\n  margin-bottom: 15px;\n  max-width: 85%;\n  animation: fadeIn 0.3s ease-in-out;\n  position: relative;\n}\n\n.ai-modal .user-message {\n  background: linear-gradient(135deg, #2b6777, #52ab98);\n  color: white;\n  border-radius: 12px 12px 0 12px;\n  padding: 12px 16px;\n  margin-left: auto;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.ai-modal .ai-message {\n  background-color: #e8f1f4;\n  border-radius: 12px 12px 12px 0;\n  padding: 12px 16px;\n  margin-right: auto;\n  color: #333;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.ai-modal .error {\n  background-color: #ffebee;\n  color: #e74c3c;\n  border-radius: 12px;\n  padding: 12px 16px;\n  margin: 10px auto;\n  text-align: center;\n  border: 1px solid rgba(231, 76, 60, 0.3);\n  max-width: 90%;\n}\n\n.ai-modal .loading {\n  background-color: transparent;\n  box-shadow: none;\n  display: flex;\n  justify-content: center;\n  margin: 15px auto;\n}\n\n.ai-modal .message-content {\n  word-break: break-word;\n}\n\n.ai-modal .message-content p {\n  margin: 0;\n}\n\n.ai-modal .status {\n  font-size: 11px;\n  display: flex;\n  align-items: center;\n  margin-top: 5px;\n  opacity: 0.8;\n}\n\n.ai-modal .user-message .status {\n  justify-content: flex-end;\n}\n\n.ai-modal .ai-message .status {\n  justify-content: flex-start;\n}\n\n.ai-modal .input-container {\n  display: flex;\n  padding: 15px 0;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.ai-modal .message-input {\n  flex: 1;\n  border: 1px solid #c8d8e4;\n  border-radius: 24px;\n  padding: 12px 20px;\n  font-size: 14px;\n  transition: all 0.3s ease;\n}\n\n.ai-modal .message-input:focus {\n  outline: none;\n  border-color: #52ab98;\n  box-shadow: 0 0 0 3px rgba(82, 171, 152, 0.25);\n}\n\n.ai-modal .send-button {\n  background: linear-gradient(135deg, #2b6777, #52ab98);\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 42px;\n  height: 42px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.ai-modal .send-button:hover:not(:disabled) {\n  background: linear-gradient(135deg, #245a67, #479e8c);\n  transform: scale(1.05);\n}\n\n.ai-modal .send-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.ai-modal .modal-footer {\n  border-top: 1px solid #f2f2f2;\n  padding: 15px 25px;\n}\n\n.ai-modal .clear-button {\n  background-color: transparent;\n  color: #2b6777;\n  border: 1px solid #c8d8e4;\n  border-radius: 8px;\n  padding: 10px 20px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.ai-modal .clear-button:hover {\n  background-color: #f2f2f2;\n  border-color: #2b6777;\n}\n\n.ai-modal .cancel-button {\n  background-color: transparent;\n  color: #2b6777;\n  border: 1px solid #c8d8e4;\n  border-radius: 8px;\n  padding: 10px 20px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.ai-modal .cancel-button:hover {\n  background-color: #f2f2f2;\n  border-color: #2b6777;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Temporal Activity Modal Styles */\n.temporal-modal .modal-content {\n  border-radius: 16px;\n  border: none;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.temporal-modal .modal-header {\n  background: linear-gradient(135deg, #2b6777, #52ab98);\n  color: white;\n  border-bottom: none;\n  padding: 20px 25px;\n}\n\n.temporal-modal .modal-title {\n  font-weight: 600;\n  font-size: 1.2rem;\n}\n\n.temporal-modal .modal-body {\n  padding: 25px;\n  background-color: #ffffff;\n}\n\n.temporal-modal .form-group {\n  margin-bottom: 20px;\n}\n\n.temporal-modal .form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #2b6777;\n}\n\n.temporal-modal .dropdown-toggle {\n  background-color: #f2f2f2;\n  border: 1px solid #c8d8e4;\n  border-radius: 8px;\n  padding: 10px 15px;\n  text-align: left;\n  color: #333;\n  transition: all 0.3s ease;\n  min-width: 200px;\n}\n\n.temporal-modal .dropdown-toggle:hover,\n.temporal-modal .dropdown-toggle:focus {\n  background-color: #e8f0f5;\n  border-color: #52ab98;\n}\n\n.temporal-modal .dropdown-menu {\n  max-height: 300px;\n  overflow-y: auto;\n  border-radius: 8px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e0e0e0;\n}\n\n.temporal-modal .dropdown-item {\n  padding: 10px 15px;\n  transition: background-color 0.2s;\n}\n\n.temporal-modal .dropdown-item:hover {\n  background-color: #e8f0f5;\n  color: #2b6777;\n}\n\n.temporal-modal .action-button {\n  background: linear-gradient(135deg, #2b6777, #52ab98);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 10px 20px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  margin-right: 10px;\n}\n\n.temporal-modal .action-button:hover:not(:disabled) {\n  background: linear-gradient(135deg, #245a67, #479e8c);\n  box-shadow: 0 4px 12px rgba(43, 103, 119, 0.3);\n  transform: translateY(-2px);\n}\n\n.temporal-modal .action-button:disabled {\n  background: #a0a0a0;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.temporal-modal .secondary-button {\n  background-color: #f2f2f2;\n  color: #2b6777;\n  border: 1px solid #c8d8e4;\n  border-radius: 8px;\n  padding: 10px 20px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  margin-right: 10px;\n}\n\n.temporal-modal .secondary-button:hover {\n  background-color: #e8f0f5;\n  border-color: #2b6777;\n}\n\n.temporal-modal .modal-footer {\n  border-top: 1px solid #f2f2f2;\n  padding: 15px 25px;\n}\n\n.temporal-modal .form-control {\n  border-radius: 8px;\n  padding: 12px 15px;\n  border: 1px solid #c8d8e4;\n  transition: all 0.3s ease;\n}\n\n.temporal-modal .form-control:focus {\n  border-color: #52ab98;\n  box-shadow: 0 0 0 3px rgba(82, 171, 152, 0.25);\n  outline: none;\n}\n\n.temporal-modal .tracking-options {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n}\n\n.temporal-modal .button-container {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n/* Dashboard Styles */\n.dashboard-modal .modal-content {\n  border-radius: 16px;\n  border: none;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n}\n\n.dashboard-modal .modal-body {\n  padding: 25px;\n}\n\n.dashboard-modal .modal-xl {\n  max-width: 96%;\n  margin: 20px auto;\n}\n\n.dashboard-modal .table-container {\n  max-height: 65vh;\n  overflow-y: auto;\n  margin-top: 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);\n}\n\n.dashboard-modal .table {\n  margin-bottom: 0;\n}\n\n.dashboard-modal .table th {\n  position: sticky;\n  top: 0;\n  background-color: #f8f9fa;\n  z-index: 10;\n  padding: 15px 10px;\n  border-bottom: 2px solid #dee2e6;\n  color: #2b6777;\n  font-weight: 600;\n}\n\n.dashboard-modal .table td {\n  padding: 12px 10px;\n  vertical-align: middle;\n}\n\n.dashboard-modal .table-striped > tbody > tr:nth-of-type(odd) {\n  background-color: rgba(200, 216, 228, 0.1);\n}\n\n.dashboard-modal .table-bordered {\n  border: 1px solid #e0e0e0;\n}\n\n.dashboard-modal .table-bordered td, \n.dashboard-modal .table-bordered th {\n  border: 1px solid #e0e0e0;\n}\n\n.dashboard-modal .form-inline {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 20px;\n}\n\n/* Activity Results Modal */\n.activity-results-modal .modal-body {\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.activity-results-modal .table-container {\n  overflow-x: auto;\n  margin-top: 10px;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.activity-results-modal table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 0;\n}\n\n.activity-results-modal th {\n  background-color: #f5f7f8;\n  color: #2b6777;\n  font-weight: 600;\n  padding: 12px 16px;\n  text-align: left;\n}\n\n.activity-results-modal td {\n  padding: 12px 16px;\n  border-top: 1px solid #eaeaea;\n}\n\n.activity-results-modal tr:hover {\n  background-color: rgba(200, 216, 228, 0.1);\n}\n\n/* Upload Sheets Modal */\n.upload-modal .modal-body {\n  padding: 30px;\n}\n\n.upload-modal .form-label {\n  color: #2b6777;\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n\n.upload-modal .form-control {\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #c8d8e4;\n}\n\n.upload-modal .upload-button {\n  background: linear-gradient(135deg, #2b6777, #52ab98);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 20px;\n  font-weight: 500;\n  width: 100%;\n  margin-top: 20px;\n  transition: all 0.3s ease;\n}\n\n.upload-modal .upload-button:hover {\n  background: linear-gradient(135deg, #245a67, #479e8c);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(43, 103, 119, 0.3);\n}\n\n.upload-modal .results-container {\n  background-color: #f7f9fc;\n  border-radius: 8px;\n  padding: 20px;\n  margin-top: 20px;\n  border-left: 4px solid #52ab98;\n}\n\n/* App-wide modal backdrop blur (matches Admin Upload Sheets) */\n.modal-backdrop,\n.admin-motion-blur-backdrop,\n.employee-panel-overlay-backdrop {\n  background: rgba(15, 23, 42, 0.35) !important;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\n/* Upload Sheets — custom overlay (replaces Bootstrap .modal-backdrop) */\n.admin-motion-blur-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1050;\n}\n\n.admin-upload-sheets-modal {\n  z-index: 1055;\n}\n\n/* Employee Panel Styles */\n.employee-task-modal .modal-content {\n  border: none;\n  border-radius: 16px;\n  box-shadow: 0 10px 30px rgba(43, 103, 119, 0.2);\n  overflow: hidden;\n}\n\n.employee-task-modal .modal-header {\n  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);\n  color: #ffffff;\n  padding: 1.25rem 1.5rem;\n  border-bottom: none;\n}\n\n.employee-task-modal .modal-title {\n  font-weight: 600;\n  font-size: 1.25rem;\n}\n\n.employee-task-modal .modal-header .btn-close {\n  color: #ffffff;\n  opacity: 0.8;\n  transition: all 0.3s ease;\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e\") center/1em auto no-repeat;\n}\n\n.employee-task-modal .modal-header .btn-close:hover {\n  opacity: 1;\n  transform: rotate(90deg);\n}\n\n.employee-task-modal .modal-body {\n  padding: 1.5rem;\n  background-color: #ffffff;\n}\n\n.employee-task-modal form {\n  display: flex;\n  flex-direction: column;\n}\n\n.employee-task-modal .mb-3 {\n  margin-bottom: 1.25rem !important;\n}\n\n.employee-task-modal .form-label {\n  font-weight: 500;\n  color: #2b6777;\n  margin-bottom: 0.5rem;\n  font-size: 0.95rem;\n}\n\n.employee-task-modal .form-label.text-red {\n  color: #e74c3c;\n}\n\n.employee-task-modal input[type=\"text\"],\n.employee-task-modal input[type=\"number\"],\n.employee-task-modal textarea,\n.employee-task-modal select,\n.employee-task-modal .react-datepicker-wrapper {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: 1px solid #c8d8e4;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  background-color: #f2f2f2;\n  transition: all 0.3s ease;\n}\n\n.employee-task-modal input[type=\"text\"]:focus,\n.employee-task-modal input[type=\"number\"]:focus,\n.employee-task-modal textarea:focus,\n.employee-task-modal select:focus,\n.employee-task-modal .form-control:focus {\n  outline: none;\n  border-color: #52ab98;\n  box-shadow: 0 0 0 3px rgba(82, 171, 152, 0.2);\n  background-color: #ffffff;\n}\n\n.employee-task-modal input[type=\"text\"]::placeholder,\n.employee-task-modal input[type=\"number\"]::placeholder,\n.employee-task-modal textarea::placeholder {\n  color: #8a9ca8;\n}\n\n.employee-task-modal input[type=\"text\"]:disabled,\n.employee-task-modal input[type=\"number\"]:disabled {\n  background-color: #e9ecef;\n  cursor: not-allowed;\n  opacity: 0.8;\n}\n\n.employee-task-modal select {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%232b6777' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 16px 12px;\n  appearance: none;\n}\n\n.employee-task-modal textarea {\n  min-height: 100px;\n  resize: vertical;\n}\n\n.employee-task-modal .btn {\n  border-radius: 8px;\n  font-weight: 500;\n  padding: 0.75rem 1.5rem;\n  transition: all 0.3s ease;\n}\n\n.employee-task-modal .btn-primary {\n  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);\n  border: none;\n  color: white;\n}\n\n.employee-task-modal .btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(43, 103, 119, 0.2);\n}\n\n.employee-task-modal .btn-primary:active {\n  transform: translateY(0);\n}\n\n.employee-task-modal .btn-secondary {\n  background-color: #c8d8e4;\n  border: none;\n  color: #2b6777;\n}\n\n.employee-task-modal .btn-secondary:hover {\n  background-color: #b6c9d8;\n  color: #2b6777;\n}\n\n.employee-task-modal .position-relative {\n  position: relative;\n}\n\n.employee-task-modal .btn-sm {\n  padding: 0.4rem 0.75rem;\n  font-size: 0.875rem;\n}\n\n.employee-task-modal .spinner-border-sm {\n  width: 1rem;\n  height: 1rem;\n  border-width: 0.2em;\n}\n\n.employee-task-modal .modal-footer {\n  background-color: #f8f9fa;\n  border-top: 1px solid #eaeaea;\n  padding: 1rem 1.5rem;\n}\n\n/* Add / Edit job modals: polished “sheet” layout */\n.employee-task-modal .employee-job-form-sheet {\n  border-radius: 18px;\n  overflow: hidden;\n  box-shadow:\n    0 4px 6px rgba(43, 103, 119, 0.04),\n    0 22px 50px rgba(25, 78, 92, 0.18);\n}\n\n.employee-task-modal .employee-job-form-modal-header {\n  position: relative;\n  background: linear-gradient(118deg, #1f5566 0%, #2b6777 38%, #3d9a87 100%);\n  color: #fff;\n  border-bottom: none;\n  padding-top: 1.35rem;\n  padding-bottom: 1.35rem;\n  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.12);\n}\n\n.employee-task-modal .employee-job-form-modal-header::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 3px;\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0.45) 0%,\n    rgba(255, 255, 255, 0.08) 45%,\n    transparent 100%\n  );\n  pointer-events: none;\n}\n\n.employee-task-modal .employee-job-form-modal-header .modal-title {\n  color: #fff;\n  letter-spacing: -0.02em;\n}\n\n.employee-task-modal .employee-job-form-header-sub {\n  font-size: 0.8125rem;\n  line-height: 1.35;\n  color: rgba(255, 255, 255, 0.78);\n  font-weight: 400;\n  max-width: 36rem;\n}\n\n.employee-task-modal .employee-job-form-sheet .modal-body {\n  background: linear-gradient(180deg, #e8f2f0 0%, #f0f6f5 22%, #f7faf9 55%, #ffffff 100%);\n  padding: 1.5rem 1.65rem 1.35rem;\n}\n\n.employee-task-modal .employee-job-form {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.employee-task-modal .employee-job-form-section {\n  background: #ffffff;\n  border: 1px solid rgba(43, 103, 119, 0.1);\n  border-radius: 14px;\n  padding: 1.25rem 1.35rem 1.35rem;\n  margin-bottom: 1rem;\n  box-shadow:\n    0 1px 2px rgba(43, 103, 119, 0.04),\n    0 8px 24px rgba(43, 103, 119, 0.06);\n}\n\n.employee-task-modal .employee-job-form-section:last-of-type {\n  margin-bottom: 0;\n}\n\n.employee-task-modal .employee-job-form-section-title {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  font-size: 0.6875rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: #245a6a;\n  margin-bottom: 1rem;\n  padding-bottom: 0.65rem;\n  border-bottom: 1px solid rgba(82, 171, 152, 0.22);\n}\n\n.employee-task-modal .employee-job-form-section-title::before {\n  content: \"\";\n  flex-shrink: 0;\n  width: 4px;\n  height: 14px;\n  border-radius: 3px;\n  background: linear-gradient(180deg, #52ab98 0%, #2b6777 100%);\n  box-shadow: 0 1px 3px rgba(43, 103, 119, 0.35);\n}\n\n/* Inputs inside job sheet: cleaner than default modal grey */\n.employee-task-modal .employee-job-form-sheet input[type=\"text\"],\n.employee-task-modal .employee-job-form-sheet input[type=\"number\"],\n.employee-task-modal .employee-job-form-sheet textarea,\n.employee-task-modal .employee-job-form-sheet select,\n.employee-task-modal .employee-job-form-sheet .react-datepicker-wrapper .form-control {\n  background-color: #fbfdfe;\n  border-color: #c5d8e0;\n  box-shadow: inset 0 1px 2px rgba(43, 103, 119, 0.035);\n}\n\n.employee-task-modal .employee-job-form-sheet input[type=\"text\"]:hover,\n.employee-task-modal .employee-job-form-sheet input[type=\"number\"]:hover,\n.employee-task-modal .employee-job-form-sheet textarea:hover,\n.employee-task-modal .employee-job-form-sheet select:hover {\n  border-color: #a8c5d2;\n}\n\n.employee-task-modal .employee-job-form-sheet .form-select {\n  background-color: #fbfdfe;\n  border-color: #c5d8e0;\n}\n\n.employee-task-modal .employee-job-form-sheet .form-text {\n  color: #5a7585;\n  font-size: 0.8125rem;\n}\n\n.employee-task-modal .employee-job-form-desc-wrap {\n  margin-bottom: 1.1rem !important;\n}\n\n.employee-task-modal .employee-job-form-desc-toolbar {\n  margin-bottom: 0.5rem;\n}\n\n.employee-task-modal .employee-job-form-desc-inner {\n  padding: 0.65rem 0.65rem 0.65rem;\n  background: linear-gradient(180deg, #f4faf9 0%, #fbfdfe 100%);\n  border: 1px solid rgba(82, 171, 152, 0.2);\n  border-radius: 12px;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.85);\n}\n\n.employee-task-modal .employee-job-form-desc-inner .employee-job-form-textarea,\n.employee-task-modal .employee-job-form-desc-inner textarea.form-control {\n  background: #ffffff;\n  border-color: #c5d8e0;\n  border-radius: 10px;\n}\n\n.employee-task-modal .employee-job-form-textarea {\n  min-height: 8rem;\n  resize: vertical;\n}\n\n.employee-task-modal .employee-job-form-ai-btn {\n  border-radius: 999px;\n  padding: 0.45rem 0.95rem;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  box-shadow:\n    0 2px 8px rgba(43, 103, 119, 0.22),\n    0 1px 0 rgba(255, 255, 255, 0.2) inset;\n}\n\n.employee-task-modal .employee-job-form-ai-btn:disabled {\n  opacity: 0.55;\n  transform: none;\n  box-shadow: none;\n}\n\n.employee-task-modal .employee-github-link-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  align-items: center;\n  min-height: 2.45rem;\n  padding: 0.3rem 0.5rem;\n  border: 1px solid #c5d8e0;\n  border-radius: 10px;\n  background: #ffffff;\n}\n\n.employee-task-modal .employee-github-link-tags:focus-within {\n  border-color: #2b6777;\n  box-shadow: 0 0 0 0.2rem rgba(43, 103, 119, 0.18);\n}\n\n.employee-task-modal .employee-github-link-tags-entry {\n  display: flex;\n  flex: 1 1 10rem;\n  align-items: center;\n  gap: 0.45rem;\n  min-width: 0;\n}\n\n.employee-task-modal .employee-github-link-tags-entry .employee-github-link-tags-input {\n  flex: 1 1 auto;\n  min-width: 0;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  padding: 0.25rem 0.2rem;\n  font-size: 0.9375rem;\n}\n\n.employee-task-modal .employee-github-link-tags-add-btn {\n  flex-shrink: 0;\n  white-space: nowrap;\n  font-weight: 600;\n  border-radius: 8px;\n  padding-inline: 0.55rem;\n}\n\n.employee-task-modal .employee-github-link-tag {\n  max-width: 100%;\n  font-weight: 500;\n  font-size: 0.8125rem;\n  padding: 0.35rem 0.35rem 0.35rem 0.5rem;\n}\n\n.employee-task-modal .employee-job-form-actions {\n  margin-top: 0.25rem;\n  padding: 1rem 1.2rem !important;\n  border-radius: 12px;\n  border: 1px solid rgba(43, 103, 119, 0.1) !important;\n  background: rgba(255, 255, 255, 0.92);\n  box-shadow: 0 4px 20px rgba(43, 103, 119, 0.07);\n}\n\n.employee-task-modal .employee-job-form-actions .btn-primary {\n  min-width: 10.5rem;\n  border-radius: 10px;\n  padding-top: 0.65rem;\n  padding-bottom: 0.65rem;\n  font-weight: 600;\n}\n\n.employee-task-modal .employee-job-form-sheet .modal-footer {\n  background: linear-gradient(180deg, #f2f8f7 0%, #e8f0ef 100%);\n  border-top: 1px solid rgba(43, 103, 119, 0.12);\n  padding: 0.9rem 1.65rem;\n}\n\n.employee-task-modal .employee-job-form-sheet .modal-footer .btn-secondary {\n  border-radius: 10px;\n  font-weight: 500;\n}\n\n/* Employee panel tables */\n.employee-panel .table {\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(43, 103, 119, 0.08);\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.employee-panel .table thead th {\n  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);\n  color: #ffffff;\n  font-weight: 500;\n  border: none;\n  padding: 0.75rem 1rem;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.employee-panel .table tbody td {\n  padding: 0.75rem 1rem;\n  border-top: none;\n  border-bottom: 1px solid #e9ecef;\n  vertical-align: middle;\n}\n\n.employee-panel .table-light {\n  --bs-table-bg: transparent;\n}\n\n.employee-panel .table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.employee-panel .table tbody tr:hover {\n  background-color: rgba(200, 216, 228, 0.15);\n}\n\n.employee-panel .badge {\n  font-weight: 500;\n  padding: 0.5em 0.75em;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.employee-panel .badge:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.employee-panel .badge.text-bg-primary {\n  background-color: #2b6777 !important;\n}\n\n.employee-panel .badge.text-bg-success {\n  background-color: #52ab98 !important;\n}\n\n.employee-panel .badge.text-bg-warning {\n  background-color: #f9bc60 !important;\n  color: #343a40 !important;\n}\n\n.employee-panel .badge.text-bg-danger {\n  background-color: #e74c3c !important;\n}\n\n.employee-panel .badge.text-bg-secondary {\n  background-color: #6c757d !important;\n}\n\n.employee-panel .search-bar {\n  margin-bottom: 1.5rem;\n}\n\n.employee-panel .search-bar .form-control {\n  border-radius: 8px;\n  padding: 0.75rem 1.25rem;\n  border: 1px solid #c8d8e4;\n  background-color: #f2f2f2;\n  transition: all 0.3s ease;\n}\n\n.employee-panel .search-bar .form-control:focus {\n  border-color: #52ab98;\n  box-shadow: 0 0 0 3px rgba(82, 171, 152, 0.2);\n  background-color: #ffffff;\n}\n\n.employee-panel .card-header {\n  background: transparent;\n  border-bottom: none;\n  padding: 1.25rem 0;\n}\n\n.employee-panel .card-header .heading h2 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #2b6777;\n  margin: 0;\n}\n\n.employee-panel .card-header .btn-primary {\n  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);\n  border: none;\n  border-radius: 8px;\n  padding: 0.75rem 1.5rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.employee-panel .card-header .btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(43, 103, 119, 0.2);\n}\n\n@media (max-width: 767.98px) {\n  .employee-panel .card-header .employee-jobs-add-btn {\n    width: 100%;\n  }\n}\n\n.employee-panel .header {\n  padding: 1.5rem 0;\n  border-bottom: 1px solid #e9ecef;\n  margin-bottom: 1.5rem;\n}\n\n.employee-panel .header h2 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #2b6777;\n  margin: 0;\n}\n\n.employee-panel .header .btn-danger {\n  background-color: #e74c3c;\n  border: none;\n  border-radius: 8px;\n  padding: 0.75rem 1.5rem;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.employee-panel .header .btn-danger:hover {\n  background-color: #c0392b;\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(231, 76, 60, 0.2);\n}\n\n/* Employee workspace tabs — matches panel header / teal theme */\n.employee-panel .employee-tabs-bar {\n  padding: 0 0 1.25rem;\n  margin-bottom: 0.25rem;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.employee-panel .employee-tabs-bar-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 1rem 1.5rem;\n}\n\n.employee-panel .employee-tabs-heading {\n  flex: 1 1 200px;\n  min-width: 0;\n}\n\n.employee-panel .employee-tabs-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #2b6777;\n  margin: 0 0 0.2rem;\n  letter-spacing: -0.02em;\n}\n\n.employee-panel .employee-tabs-subtitle {\n  margin: 0;\n  font-size: 0.9rem;\n  color: #6c757d;\n  font-weight: 400;\n  line-height: 1.4;\n  max-width: 36rem;\n}\n\n.employee-panel .employee-tabs-group {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.35rem;\n  background: linear-gradient(180deg, #f5faf9 0%, #eef4f4 100%);\n  padding: 0.4rem;\n  border-radius: 10px;\n  border: 1px solid #dce8e6;\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.85),\n    0 2px 8px rgba(43, 103, 119, 0.06);\n}\n\n.employee-panel .employee-tab-btn {\n  border: none;\n  background: transparent;\n  color: #2b6777;\n  font-weight: 600;\n  font-size: 0.9rem;\n  padding: 0.65rem 1.25rem;\n  border-radius: 8px;\n  cursor: pointer;\n  transition:\n    color 0.2s ease,\n    background 0.2s ease,\n    box-shadow 0.2s ease,\n    transform 0.15s ease;\n  white-space: nowrap;\n}\n\n.employee-panel .employee-tab-btn:hover:not(.active) {\n  background: rgba(255, 255, 255, 0.75);\n  color: #1e4d5a;\n}\n\n.employee-panel .employee-tab-btn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(82, 171, 152, 0.45);\n}\n\n.employee-panel .employee-tab-btn.active {\n  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);\n  color: #ffffff;\n  box-shadow: 0 4px 14px rgba(43, 103, 119, 0.28);\n}\n\n.employee-panel .employee-tab-btn.active:hover {\n  color: #ffffff;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 18px rgba(43, 103, 119, 0.32);\n}\n\n/* Let wide tables scroll: fluid columns default to min-content and clip overflow */\n.employee-panel > .container-fluid,\n.employee-panel .employee-workspace {\n  min-width: 0;\n  max-width: 100%;\n}\n\n.employee-panel .employee-tabs-panel {\n  padding-top: 0.35rem;\n  animation: employee-tab-fade 0.22s ease-out;\n  min-width: 0;\n  max-width: 100%;\n}\n\n@keyframes employee-tab-fade {\n  from {\n    opacity: 0;\n    transform: translateY(4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (max-width: 576px) {\n  .employee-panel .employee-tabs-bar-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .employee-panel .employee-tabs-group {\n    justify-content: stretch;\n  }\n\n  .employee-panel .employee-tab-btn {\n    flex: 1;\n    text-align: center;\n    padding: 0.6rem 0.75rem;\n  }\n}\n\n.employee-panel .text-green {\n  color: #52ab98 !important;\n}\n\n.employee-panel .text-truncate {\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Jobs table: responsive scroll, compact type, clip + tooltip cells */\n.employee-panel .employee-jobs-table-responsive,\n.employee-panel .employee-subjobs-table-responsive,\n.employee-panel .employee-logged-hours-table-responsive {\n  width: 100%;\n  max-width: 100%;\n  overflow-x: auto;\n}\n\n.employee-panel .employee-jobs-table-responsive {\n  -webkit-overflow-scrolling: touch;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(43, 103, 119, 0.08);\n}\n\n.employee-panel .table.employee-jobs-table {\n  font-size: 0.8125rem;\n  min-width: 760px;\n  margin-bottom: 0;\n  --jobs-row-border: #e8edf2;\n  --jobs-row-stripe: #f6f8fa;\n  background-color: #fff;\n  border: 1px solid #dde5ec;\n  border-collapse: separate;\n  border-spacing: 0;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.employee-panel .table.employee-jobs-table thead th {\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: none;\n  padding: 0.65rem 0.75rem;\n  vertical-align: middle;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  white-space: nowrap;\n}\n\n.employee-panel .table.employee-jobs-table thead th.jobs-th-primary {\n  text-align: left;\n}\n\n.employee-panel .table.employee-jobs-table thead th.jobs-th-num {\n  text-align: center;\n  width: 4.25rem;\n  max-width: 4.5rem;\n}\n\n.employee-panel .table.employee-jobs-table thead th.jobs-th-date {\n  text-align: center;\n}\n\n.employee-panel .table.employee-jobs-table thead th.jobs-th-status {\n  text-align: center;\n  width: 6.5rem;\n}\n\n.employee-panel .table.employee-jobs-table tbody td.jobs-td-status {\n  text-align: center;\n}\n\n.employee-panel .table.employee-jobs-table thead th.jobs-th-github {\n  text-align: center;\n}\n\n.employee-panel .table.employee-jobs-table thead th.jobs-th-actions {\n  text-align: center;\n  width: 1%;\n}\n\n.employee-panel .table.employee-jobs-table tbody td {\n  padding: 0.6rem 0.75rem;\n  vertical-align: middle;\n  border-bottom: 1px solid var(--jobs-row-border);\n  color: #334155;\n}\n\n.employee-panel .table.employee-jobs-table tbody tr:nth-child(even) td {\n  background-color: var(--jobs-row-stripe);\n}\n\n.employee-panel .table.employee-jobs-table tbody tr:hover td {\n  background-color: rgba(200, 216, 228, 0.35) !important;\n}\n\n.employee-panel .table.employee-jobs-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.employee-panel .table.employee-jobs-table tbody td:nth-child(1),\n.employee-panel .table.employee-jobs-table tbody td:nth-child(2) {\n  text-align: left;\n}\n\n.employee-panel .table.employee-jobs-table tbody td.jobs-td-num {\n  text-align: center;\n  font-variant-numeric: tabular-nums;\n  font-weight: 500;\n  color: #475569;\n  width: 4.25rem;\n}\n\n.employee-panel .table.employee-jobs-table tbody td.jobs-td-date {\n  text-align: center;\n  font-variant-numeric: tabular-nums;\n  color: #475569;\n}\n\n.employee-panel .table.employee-jobs-table tbody td:nth-child(2) .jobs-clip-text {\n  font-weight: 500;\n  color: #1e293b;\n}\n\n.employee-panel .table.employee-jobs-table tbody td:nth-child(2) .jobs-clip-wrap {\n  max-width: min(14rem, 36vw);\n}\n\n.employee-panel .table.employee-jobs-table .badge {\n  font-size: 0.7rem;\n  padding: 0.35em 0.55em;\n}\n\n/* Jobs: search + status filter — row aligned to end (right) */\n.employee-panel .employee-jobs-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.75rem 1.25rem;\n  width: 100%;\n  max-width: min(44rem, 100%);\n  margin-left: auto;\n  margin-right: 0;\n}\n\n.employee-panel .employee-jobs-toolbar .employee-jobs-search-field {\n  flex: 1 1 14rem;\n  min-width: 0;\n  max-width: 22rem;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.employee-panel .employee-jobs-toolbar .employee-jobs-toolbar-search-input {\n  margin-bottom: 0;\n  width: 100%;\n}\n\n.employee-panel .employee-jobs-toolbar .employee-jobs-status-filter {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem 0.65rem;\n}\n\n.employee-panel .employee-jobs-toolbar .employee-jobs-status-label {\n  margin: 0;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: #2b6777;\n  line-height: 1.5;\n  white-space: nowrap;\n}\n\n/* Toolbar select: forced theme so the current value (e.g. All) stays visible in all browsers */\n.employee-panel .employee-jobs-toolbar .employee-jobs-toolbar-status-dropdown {\n  margin-left: 0;\n  min-width: 10.5rem;\n  min-height: 2.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  padding: 0.45rem 2.25rem 0.45rem 0.75rem;\n  color: #fff !important;\n  -webkit-text-fill-color: #fff;\n  background-color: #2b6777;\n  background-image: url(\"data:image/svg+xml,%3csvg width='16' height='16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M4 6l4 4 4-4'/%3e%3c/svg%3e\"),\n    linear-gradient(135deg, #2b6777 0%, #52ab98 100%);\n  background-repeat: no-repeat, no-repeat;\n  background-position: right 0.65rem center, center;\n  background-size: 16px 16px, 100% 100%;\n  border: 1px solid #1c3932;\n  border-radius: 8px;\n  box-shadow: 0 2px 6px rgba(43, 103, 119, 0.12);\n  line-height: 1.5;\n}\n\n.employee-panel .employee-logged-hours-search {\n  width: 100%;\n  max-width: 18rem;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .employee-panel .employee-jobs-toolbar {\n    max-width: min(40rem, 100%);\n  }\n\n  .employee-panel .employee-logged-hours-search {\n    max-width: 20rem;\n  }\n}\n\n/* Clipped text + hover tooltip (scoped to jobs table) */\n.employee-panel .table.employee-jobs-table .jobs-clip-wrap {\n  position: relative;\n  text-align: left;\n}\n\n.employee-panel .table.employee-jobs-table .jobs-clip-text {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.employee-panel .table.employee-jobs-table .jobs-client-cell .jobs-clip-wrap {\n  max-width: min(7.5rem, 18vw);\n}\n\n.employee-panel .table.employee-jobs-table .jobs-desc-cell .jobs-clip-wrap {\n  max-width: min(10rem, 22vw);\n}\n\n.employee-panel .table.employee-jobs-table .jobs-note-cell .jobs-clip-wrap {\n  max-width: min(6.5rem, 16vw);\n}\n\n.employee-panel .table.employee-jobs-table .jobs-team-clip.jobs-clip-wrap {\n  max-width: min(9.5rem, 20vw);\n  margin-inline: auto;\n}\n\n.employee-panel .table.employee-jobs-table .jobs-tooltip-bubble {\n  display: none;\n  position: absolute;\n  z-index: 1080;\n  left: 50%;\n  transform: translateX(-50%);\n  top: calc(100% + 6px);\n  min-width: min(100%, 12rem);\n  max-width: min(420px, 85vw);\n  max-height: 220px;\n  overflow-y: auto;\n  padding: 0.55rem 0.7rem;\n  background: #1a3a42;\n  color: #f8fafb;\n  font-size: 0.8125rem;\n  line-height: 1.45;\n  border-radius: 8px;\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.22);\n  white-space: pre-wrap;\n  word-break: break-word;\n  text-align: left;\n  pointer-events: auto;\n}\n\n.employee-panel .table.employee-jobs-table .jobs-clip-wrap:hover .jobs-tooltip-bubble {\n  display: block;\n}\n\n.employee-panel .table.employee-jobs-table .jobs-tooltip-bubble::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 100%;\n  height: 8px;\n}\n\n.employee-panel .table.employee-jobs-table .jobs-tooltip-bubble::after {\n  content: \"\";\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  margin-left: -7px;\n  border: 7px solid transparent;\n  border-bottom-color: #1a3a42;\n}\n\n@media (hover: none) {\n  .employee-panel .table.employee-jobs-table .jobs-tooltip-bubble {\n    display: none !important;\n  }\n}\n\n/* Pagination styling */\n.employee-panel .pagination {\n  margin-top: 1.5rem;\n  display: flex;\n  justify-content: center;\n}\n\n.employee-panel .pagination button {\n  background-color: #f2f2f2;\n  border: none;\n  color: #2b6777;\n  padding: 0.5rem 1rem;\n  margin: 0 0.25rem;\n  border-radius: 6px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.employee-panel .pagination button:hover:not(:disabled) {\n  background-color: #c8d8e4;\n}\n\n.employee-panel .pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.employee-panel .pagination .active-page {\n  background-color: #2b6777;\n  color: white;\n}\n\n/* Employee table pagination (windowed pages + ellipsis) */\n.employee-panel ul.pagination.employee-table-pagination {\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  row-gap: 0.35rem;\n}\n\n.employee-panel .employee-table-pagination .page-item .page-link {\n  margin: 0;\n  border-radius: 6px;\n  min-width: 2.35rem;\n  text-align: center;\n}\n\n.employee-panel .employee-table-pagination .page-item + .page-item {\n  margin-left: 0.125rem;\n}\n\n.employee-panel .employee-table-pagination .page-link.active {\n  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);\n  color: #fff;\n  border-color: transparent;\n  z-index: 1;\n}\n\n.employee-panel .employee-table-pagination .page-item.disabled .page-link {\n  background-color: #f8f9fa;\n  color: #6c757d;\n  border-color: #dee2e6;\n  opacity: 1;\n}\n\n.employee-panel .table.employee-jobs-table .jobs-actions-cell {\n  text-align: center;\n  width: 1%;\n  white-space: nowrap;\n}\n\n.employee-panel .table.employee-jobs-table .jobs-actions-cell .badge {\n  white-space: nowrap;\n}\n\n/* Actions pill — same gradient angle/colors as table header */\n.employee-panel .table.employee-jobs-table .jobs-actions-toolbar {\n  display: inline-flex;\n  align-items: stretch;\n  vertical-align: middle;\n  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);\n  border: 1px solid rgba(30, 70, 80, 0.35);\n  border-radius: 999px;\n  box-shadow: 0 2px 8px rgba(43, 103, 119, 0.28);\n  overflow: hidden;\n}\n\n.employee-panel .table.employee-jobs-table .jobs-actions-toolbar-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 2.35rem;\n  min-height: 2.125rem;\n  padding: 0.3rem 0.55rem;\n  margin: 0;\n  border: none;\n  background: transparent;\n  color: #fff;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.employee-panel .table.employee-jobs-table .jobs-actions-toolbar-btn + .jobs-actions-toolbar-btn {\n  border-left: 1px solid rgba(255, 255, 255, 0.22);\n}\n\n.employee-panel .table.employee-jobs-table .jobs-actions-toolbar-btn:hover {\n  background-color: rgba(255, 255, 255, 0.18);\n  color: #fff;\n}\n\n.employee-panel .table.employee-jobs-table .jobs-actions-toolbar-btn:focus-visible {\n  outline: 2px solid rgba(255, 255, 255, 0.85);\n  outline-offset: -2px;\n  z-index: 1;\n}\n\n.employee-panel .table.employee-jobs-table .jobs-actions-toolbar-btn svg,\n.employee-panel .table.employee-jobs-table .jobs-actions-toolbar-btn .iconify {\n  flex-shrink: 0;\n  display: block;\n}\n\n.employee-panel .table.employee-jobs-table .jobs-actions-toolbar-btn--delete {\n  color: #fff;\n}\n\n.employee-panel .table.employee-jobs-table .jobs-actions-toolbar-btn--delete:hover {\n  background-color: rgba(231, 76, 60, 0.35);\n  color: #fff;\n}\n\n.employee-panel .table.employee-jobs-table .jobs-actions-toolbar-btn--status:hover {\n  background-color: rgba(255, 255, 255, 0.22);\n}\n\n.employee-panel .table.employee-jobs-table .jobs-github-table-link {\n  color: #2b6777;\n  font-weight: 500;\n}\n\n.employee-panel .table.employee-jobs-table .jobs-github-table-link:hover {\n  color: #52ab98;\n}\n\n/* Full-screen overlay for employee Jobs modals (not Bootstrap `modal-backdrop` — avoids global cleanup removing it). */\n.employee-panel-overlay-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n}\n\n.employee-job-github-link-list li:last-child {\n  margin-bottom: 0 !important;\n}\n\n/* Job detail panel (no full-page dimmer — close via X or Escape) */\n.employee-job-detail-root {\n  z-index: 1065;\n}\n\n/* GitHub AI summary (stacked above job detail overlay) */\n.employee-github-ai-summary-backdrop {\n  z-index: 1070;\n}\n\n.employee-github-ai-summary-modal-root {\n  z-index: 1075;\n}\n\n.employee-github-ai-summary-header {\n  background: linear-gradient(135deg, #1f5566 0%, #2b6777 42%, #3d9a87 100%);\n}\n\n.employee-github-ai-summary-body {\n  white-space: pre-wrap;\n  word-break: break-word;\n  line-height: 1.6;\n  color: #334148;\n  border-color: #c8d8e4 !important;\n  max-height: min(70vh, 28rem);\n  overflow-y: auto;\n}\n\n.employee-job-detail-card {\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 8px 28px rgba(43, 103, 119, 0.18);\n}\n\n.employee-job-detail-hero {\n  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);\n}\n\n.employee-job-detail-metrics {\n  background-color: #f2f2f2;\n  border-color: #e9ecef !important;\n}\n\n.employee-job-detail-section-title {\n  color: #2b6777;\n  letter-spacing: 0.03em;\n}\n\n.employee-job-detail-info-panel {\n  padding: 1rem 1.15rem;\n}\n\n@media (min-width: 992px) {\n  .employee-job-detail-info-panel {\n    padding: 1.15rem 1.35rem;\n  }\n}\n\n.employee-job-detail-stat-accent {\n  color: #2b6777;\n}\n\n.employee-job-detail-inline-link {\n  color: #2b6777;\n  text-decoration: none;\n}\n\n.employee-job-detail-inline-link:hover {\n  color: #52ab98;\n  text-decoration: underline;\n}\n\n.employee-job-detail-label {\n  min-width: 7.5rem;\n}\n\n.employee-job-detail-prose {\n  max-height: 11rem;\n  overflow-y: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n  line-height: 1.55;\n  color: #495057;\n  border-color: #c8d8e4 !important;\n}\n\n.employee-job-detail-stat {\n  transition: box-shadow 0.15s ease, transform 0.15s ease;\n  border-color: #e9ecef !important;\n}\n\n.employee-job-detail-stat:hover {\n  box-shadow: 0 6px 16px rgba(43, 103, 119, 0.12) !important;\n}\n\n.employee-job-detail-modal-footer {\n  background-color: #f8f9fa;\n  border-top-color: #eaeaea !important;\n}\n\n/* Job detail modal: match other employee-task-modal buttons */\n.employee-task-modal.employee-job-detail-card .modal-footer .btn-outline-secondary {\n  border-color: #2b6777;\n  color: #2b6777;\n  background-color: #fff;\n}\n\n.employee-task-modal.employee-job-detail-card .modal-footer .btn-outline-secondary:hover {\n  background-color: rgba(200, 216, 228, 0.4);\n  border-color: #2b6777;\n  color: #214e5a;\n}\n\n.employee-task-modal.employee-job-detail-card .modal-footer .btn-outline-danger {\n  border-color: #e74c3c;\n  color: #e74c3c;\n}\n\n.employee-task-modal.employee-job-detail-card .modal-footer .btn-outline-danger:hover {\n  background-color: #e74c3c;\n  border-color: #e74c3c;\n  color: #fff;\n}\n\n.employee-task-modal.employee-job-detail-card .modal-footer .btn-secondary:disabled {\n  opacity: 0.45;\n}\n\n.employee-task-modal.employee-job-detail-card .modal-footer .employee-job-detail-action-btn {\n  min-height: 2.75rem;\n}\n\n.employee-task-modal.employee-job-detail-card .modal-footer .employee-job-detail-action-btn svg,\n.employee-task-modal.employee-job-detail-card .modal-footer .employee-job-detail-action-btn .iconify {\n  flex-shrink: 0;\n  display: block;\n}\n\n.employee-task-modal.employee-job-detail-card .modal-body .border.bg-light {\n  border-color: #dee2e6 !important;\n}\n\n.employee-job-detail-card .employee-job-detail-row.border-bottom {\n  border-color: #e9ecef !important;\n}\n\n/* Sub Jobs table: same responsive / compact / tooltip pattern as Jobs */\n.employee-panel .employee-subjobs-table-responsive {\n  -webkit-overflow-scrolling: touch;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(43, 103, 119, 0.08);\n}\n\n.employee-panel .table.employee-subjobs-table {\n  font-size: 0.9375rem;\n  table-layout: fixed;\n  width: 100%;\n  min-width: 980px;\n  margin-bottom: 0;\n}\n\n/* Reserve horizontal space so action icons stay on one row */\n.employee-panel .table.employee-subjobs-table th:nth-child(1),\n.employee-panel .table.employee-subjobs-table td:nth-child(1) {\n  width: 18%;\n}\n\n.employee-panel .table.employee-subjobs-table th:nth-child(2) {\n  width: 28%;\n}\n\n.employee-panel .table.employee-subjobs-table td:nth-child(2) {\n  width: 28%;\n  overflow: hidden;\n}\n\n.employee-panel .table.employee-subjobs-table th:nth-child(3),\n.employee-panel .table.employee-subjobs-table td:nth-child(3),\n.employee-panel .table.employee-subjobs-table th:nth-child(4),\n.employee-panel .table.employee-subjobs-table td:nth-child(4),\n.employee-panel .table.employee-subjobs-table th:nth-child(5),\n.employee-panel .table.employee-subjobs-table td:nth-child(5),\n.employee-panel .table.employee-subjobs-table th:nth-child(6),\n.employee-panel .table.employee-subjobs-table td:nth-child(6) {\n  width: 9%;\n}\n\n.employee-panel .table.employee-subjobs-table th:last-child,\n.employee-panel .table.employee-subjobs-table td:last-child {\n  width: 12.75rem;\n  min-width: 12.75rem;\n  max-width: 12.75rem;\n  box-sizing: border-box;\n}\n\n/* A bit more air before the trailing columns */\n.employee-panel .table.employee-subjobs-table thead th:nth-child(n + 3),\n.employee-panel .table.employee-subjobs-table tbody td:nth-child(n + 3) {\n  padding-inline: 0.45rem 0.5rem;\n}\n\n.employee-panel .table.employee-subjobs-table thead th {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  padding: 0.42rem 0.36rem;\n  vertical-align: middle;\n}\n\n.employee-panel .table.employee-subjobs-table tbody td {\n  padding: 0.38rem 0.36rem;\n  vertical-align: middle;\n}\n\n.employee-panel .table.employee-subjobs-table .badge {\n  font-size: 0.78rem;\n  padding: 0.35em 0.55em;\n}\n\n.employee-panel .table.employee-subjobs-table .jobs-clip-wrap {\n  position: relative;\n  text-align: left;\n}\n\n.employee-panel .table.employee-subjobs-table .jobs-clip-text {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.employee-panel .table.employee-subjobs-table .subjobs-id-cell .jobs-clip-wrap {\n  max-width: 100%;\n  margin-inline: auto;\n}\n\n.employee-panel .table.employee-subjobs-table .subjobs-name-cell .jobs-clip-wrap {\n  max-width: 100%;\n}\n\n.employee-panel .table.employee-subjobs-table .jobs-tooltip-bubble {\n  display: none;\n  position: absolute;\n  z-index: 1080;\n  left: 50%;\n  transform: translateX(-50%);\n  top: calc(100% + 6px);\n  min-width: min(100%, 12rem);\n  max-width: min(420px, 85vw);\n  max-height: 220px;\n  overflow-y: auto;\n  padding: 0.55rem 0.7rem;\n  background: #1a3a42;\n  color: #f8fafb;\n  font-size: 0.875rem;\n  line-height: 1.45;\n  border-radius: 8px;\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.22);\n  white-space: pre-wrap;\n  word-break: break-word;\n  text-align: left;\n  pointer-events: auto;\n}\n\n.employee-panel .table.employee-subjobs-table .jobs-clip-wrap:hover .jobs-tooltip-bubble {\n  display: block;\n}\n\n.employee-panel .table.employee-subjobs-table .jobs-tooltip-bubble::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 100%;\n  height: 8px;\n}\n\n.employee-panel .table.employee-subjobs-table .jobs-tooltip-bubble::after {\n  content: \"\";\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  margin-left: -7px;\n  border: 7px solid transparent;\n  border-bottom-color: #1a3a42;\n}\n\n@media (hover: none) {\n  .employee-panel .table.employee-subjobs-table .jobs-tooltip-bubble {\n    display: none !important;\n  }\n}\n\n.employee-panel .table.employee-subjobs-table .subjobs-actions-cell {\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.employee-panel .table.employee-subjobs-table .subjobs-actions-toolbar {\n  display: inline-flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: center;\n  gap: 0.3rem;\n}\n\n.employee-panel .table.employee-subjobs-table .subjobs-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  width: 1.72rem;\n  height: 1.72rem;\n  padding: 0;\n  margin: 0;\n  overflow: visible;\n  border: 1px solid #d0d9e3;\n  border-radius: 0.3rem;\n  background: #ffffff;\n  color: #2b6777;\n  transition: all 0.15s ease;\n}\n\n.employee-panel .table.employee-subjobs-table .subjobs-action-btn svg {\n  flex-shrink: 0;\n}\n\n.employee-panel .table.employee-subjobs-table .subjobs-action-btn:hover {\n  background: #e9f3f5;\n  border-color: #52ab98;\n  color: #1f5562;\n}\n\n.employee-panel .table.employee-subjobs-table .subjobs-action-btn--success {\n  color: #027a48;\n}\n\n.employee-panel .table.employee-subjobs-table .subjobs-action-btn--success:hover {\n  background: #ecfdf3;\n  border-color: #6ce9a6;\n  color: #027a48;\n}\n\n.employee-panel .table.employee-subjobs-table .subjobs-action-btn--muted {\n  color: #475467;\n}\n\n.employee-panel .table.employee-subjobs-table .subjobs-action-btn--muted:hover {\n  background: #f2f4f7;\n  border-color: #98a2b3;\n  color: #1d2939;\n}\n\n.employee-panel .table.employee-subjobs-table .subjobs-action-btn--danger {\n  color: #b42318;\n}\n\n.employee-panel .table.employee-subjobs-table .subjobs-action-btn--danger:hover {\n  background: #fef3f2;\n  border-color: #fda29b;\n  color: #b42318;\n}\n\n.employee-panel .table.employee-subjobs-table .subjobs-action-btn--warning {\n  color: #b54708;\n}\n\n.employee-panel .table.employee-subjobs-table .subjobs-action-btn--warning:hover {\n  background: #fffaeb;\n  border-color: #fec84b;\n  color: #b54708;\n}\n\n/* Logged hours tables: responsive / compact / tooltips (job logs + subtask logs) */\n.employee-panel .employee-logged-hours-table-responsive {\n  -webkit-overflow-scrolling: touch;\n  border-radius: 10px;\n  box-shadow: 0 4px 12px rgba(43, 103, 119, 0.08);\n}\n\n.employee-panel .table.employee-logged-hours-table {\n  font-size: 0.9375rem;\n  min-width: 800px;\n  margin-bottom: 0;\n  table-layout: fixed;\n  width: 100%;\n}\n\n.employee-panel .table.employee-logged-hours-table.employee-logged-hours-subtask-table {\n  min-width: 920px;\n  font-size: 1rem;\n}\n\n/* Daniyal — subtask log table: cap SubJob name column so date/time/status/actions stay readable */\n.employee-panel\n  .table.employee-logged-hours-table.employee-logged-hours-subtask-table\n  th:nth-child(1),\n.employee-panel\n  .table.employee-logged-hours-table.employee-logged-hours-subtask-table\n  td:nth-child(1) {\n  width: 42%;\n  vertical-align: middle;\n}\n\n.employee-panel\n  .table.employee-logged-hours-table.employee-logged-hours-subtask-table\n  td:nth-child(1) {\n  overflow: hidden;\n}\n\n.employee-panel\n  .table.employee-logged-hours-table.employee-logged-hours-subtask-table\n  .loghours-name-cell\n  .jobs-clip-wrap {\n  max-width: 100%;\n}\n\n.employee-panel\n  .table.employee-logged-hours-table.employee-logged-hours-subtask-table\n  .loghours-actions-header,\n.employee-panel\n  .table.employee-logged-hours-table.employee-logged-hours-subtask-table\n  .loghours-actions-cell {\n  width: 5.5rem;\n  max-width: 5.5rem;\n}\n\n.employee-panel\n  .table.employee-logged-hours-table.employee-logged-hours-subtask-table\n  .loghours-actions-toolbar {\n  flex-wrap: nowrap;\n  gap: 0.2rem;\n}\n\n.employee-panel .table.employee-logged-hours-table thead th {\n  font-size: 0.8125rem;\n  font-weight: 600;\n  padding: 0.42rem 0.32rem;\n  vertical-align: middle;\n}\n\n.employee-panel\n  .table.employee-logged-hours-table.employee-logged-hours-subtask-table\n  thead\n  th {\n  font-size: 0.875rem;\n}\n\n.employee-panel .table.employee-logged-hours-table tbody td {\n  padding: 0.38rem 0.32rem;\n  vertical-align: middle;\n}\n\n.employee-panel .table.employee-logged-hours-table .badge {\n  font-size: 0.78rem;\n  padding: 0.35em 0.55em;\n}\n\n.employee-panel .table.employee-logged-hours-table .jobs-clip-wrap {\n  position: relative;\n  text-align: left;\n}\n\n.employee-panel .table.employee-logged-hours-table .jobs-clip-text {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.employee-panel .table.employee-logged-hours-table .loghours-client-cell .jobs-clip-wrap {\n  max-width: min(9.6rem, 20.8vw);\n}\n\n.employee-panel .table.employee-logged-hours-table .loghours-id-header,\n.employee-panel .table.employee-logged-hours-table .loghours-id-cell {\n  min-width: 12rem;\n}\n\n.employee-panel .table.employee-logged-hours-table .loghours-col-date {\n  width: 6.35rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.employee-panel .table.employee-logged-hours-table .loghours-col-duration {\n  width: 6.15rem;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.02em;\n}\n\n.employee-panel .table.employee-logged-hours-table .loghours-col-status {\n  width: 6.65rem;\n}\n\n/* Breathing room between Date, App. time, Status, and Actions */\n.employee-panel .table.employee-logged-hours-table thead th.loghours-col-date,\n.employee-panel .table.employee-logged-hours-table tbody td.loghours-col-date,\n.employee-panel .table.employee-logged-hours-table thead th.loghours-col-duration,\n.employee-panel .table.employee-logged-hours-table tbody td.loghours-col-duration,\n.employee-panel .table.employee-logged-hours-table thead th.loghours-col-status,\n.employee-panel .table.employee-logged-hours-table tbody td.loghours-col-status,\n.employee-panel .table.employee-logged-hours-table thead th.loghours-actions-header,\n.employee-panel .table.employee-logged-hours-table tbody td.loghours-actions-cell {\n  padding-inline: 0.52rem 0.58rem;\n}\n\n.employee-panel .table.employee-logged-hours-table .loghours-id-cell .jobs-clip-wrap {\n  max-width: min(8rem, 22vw);\n  margin-inline: 0;\n}\n\n.employee-panel .table.employee-logged-hours-table .loghours-id-cell {\n  white-space: nowrap;\n}\n\n.employee-panel .table.employee-logged-hours-table .loghours-id-value {\n  display: inline-block;\n  white-space: nowrap;\n}\n\n.employee-panel .table.employee-logged-hours-table .loghours-name-cell .jobs-clip-wrap {\n  max-width: min(14rem, 32vw);\n}\n\n.employee-panel .table.employee-logged-hours-table .loghours-note-cell .jobs-clip-wrap {\n  max-width: min(7rem, 14vw);\n}\n\n.employee-panel .table.employee-logged-hours-table .jobs-tooltip-bubble {\n  display: none;\n  position: absolute;\n  z-index: 1080;\n  left: 50%;\n  transform: translateX(-50%);\n  top: calc(100% + 6px);\n  min-width: min(100%, 12rem);\n  max-width: min(420px, 85vw);\n  max-height: 220px;\n  overflow-y: auto;\n  padding: 0.55rem 0.7rem;\n  background: #1a3a42;\n  color: #f8fafb;\n  font-size: 0.875rem;\n  line-height: 1.45;\n  border-radius: 8px;\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.22);\n  white-space: pre-wrap;\n  word-break: break-word;\n  text-align: left;\n  pointer-events: auto;\n}\n\n.employee-panel .table.employee-logged-hours-table .jobs-clip-wrap:hover .jobs-tooltip-bubble {\n  display: block;\n}\n\n.employee-panel .table.employee-logged-hours-table .jobs-tooltip-bubble::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 100%;\n  height: 8px;\n}\n\n.employee-panel .table.employee-logged-hours-table .jobs-tooltip-bubble::after {\n  content: \"\";\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  margin-left: -7px;\n  border: 7px solid transparent;\n  border-bottom-color: #1a3a42;\n}\n\n@media (hover: none) {\n  .employee-panel .table.employee-logged-hours-table .jobs-tooltip-bubble {\n    display: none !important;\n  }\n}\n\n.employee-panel .table.employee-logged-hours-table .loghours-actions-header,\n.employee-panel .table.employee-logged-hours-table .loghours-actions-cell {\n  width: 5.05rem;\n  max-width: 5.05rem;\n  box-sizing: border-box;\n}\n\n.employee-panel .table.employee-logged-hours-table .loghours-actions-toolbar {\n  display: inline-flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0;\n}\n\n.employee-panel .table.employee-logged-hours-table .loghours-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  width: 1.5rem;\n  height: 1.5rem;\n  padding: 0;\n  margin: 0;\n  overflow: visible;\n  border: 1px solid #d0d9e3;\n  border-radius: 0.26rem;\n  background: #ffffff;\n  color: #2b6777;\n  transition: all 0.15s ease;\n}\n\n.employee-panel .table.employee-logged-hours-table .loghours-action-btn svg {\n  width: 1.5rem;\n  height: 1.5rem;\n  flex-shrink: 0;\n}\n\n.employee-panel .table.employee-logged-hours-table .loghours-action-btn:hover {\n  background: #e9f3f5;\n  border-color: #52ab98;\n  color: #1f5562;\n}\n\n.employee-panel .table.employee-logged-hours-table .loghours-action-btn--danger {\n  color: #b42318;\n}\n\n.employee-panel .table.employee-logged-hours-table .loghours-action-btn--danger:hover {\n  background: #fef3f2;\n  border-color: #fda29b;\n  color: #b42318;\n}\n\n.employee-panel .table.employee-logged-hours-table .loghours-actions-cell .badge {\n  white-space: nowrap;\n}\n\n.employee-panel .employee-log-detail-card {\n  border-radius: 0.9rem;\n  overflow: hidden;\n}\n\n.employee-panel .employee-log-detail-header {\n  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);\n}\n\n.employee-panel .employee-log-detail-item {\n  border: 1px solid #e2e8f0;\n  border-radius: 0.75rem;\n  padding: 0.75rem 0.85rem;\n  background: #f8fafc;\n  min-height: 100%;\n}\n\n.employee-panel .employee-log-detail-label {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: #64748b;\n  margin-bottom: 0.2rem;\n}\n\n.employee-panel .employee-log-detail-value {\n  font-size: 0.92rem;\n  font-weight: 500;\n  color: #0f172a;\n  word-break: break-word;\n}\n\n.employee-panel .employee-log-detail-notes {\n  white-space: pre-wrap;\n}\n\n.employee-panel .subjob-view-commit-repo:last-child {\n  margin-bottom: 0 !important;\n}\n\n.employee-panel .subjob-view-commit-hash {\n  font-size: 0.75rem;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  padding: 0.12rem 0.4rem;\n  color: #334155;\n}\n\n/* DatePicker custom styling */\n.react-datepicker-wrapper {\n  width: 100%;\n}\n\n.react-datepicker__input-container {\n  width: 100%;\n}\n\n.react-datepicker-popper {\n  z-index: 9999 !important;\n}\n\n.react-datepicker {\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;\n  border: 1px solid #c8d8e4 !important;\n  border-radius: 8px !important;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1) !important;\n}\n\n.react-datepicker__header {\n  background-color: #2b6777 !important;\n  border-bottom: none !important;\n  border-top-left-radius: 8px !important;\n  border-top-right-radius: 8px !important;\n  padding-top: 8px !important;\n}\n\n.react-datepicker__current-month, \n.react-datepicker__day-name {\n  color: #ffffff !important;\n}\n\n.react-datepicker__navigation {\n  top: 10px !important;\n}\n\n.react-datepicker__day--selected, \n.react-datepicker__day--in-selecting-range, \n.react-datepicker__day--in-range {\n  background-color: #52ab98 !important;\n  border-radius: 50% !important;\n}\n\n.react-datepicker__day:hover {\n  background-color: #c8d8e4 !important;\n  border-radius: 50% !important;\n}\n\n.status-dropdown {\n  background: linear-gradient(135deg, #2b6777 0%, #52ab98 100%);\n  color: #fff;\n  border: 1px solid #1c3932;\n  border-radius: 8px;\n  padding: 6px 32px 6px 12px;\n  font-size: 1rem;\n  font-weight: 500;\n  outline: none;\n  appearance: none;\n  min-width: 100px;\n  margin-left: 8px;\n  box-shadow: 0 2px 6px rgba(43, 103, 119, 0.08);\n  transition: border 0.2s, box-shadow 0.2s;\n  cursor: pointer;\n  /* Custom arrow */\n  background-image: url(\"data:image/svg+xml,%3csvg width='16' height='16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M4 6l4 4 4-4'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 16px 16px;\n}\n\n.status-dropdown:focus {\n  border: 2px solid #52ab98;\n  box-shadow: 0 0 0 2px #52ab9855;\n}\n\n.status-dropdown option {\n  color: #2b6777;\n  background: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
